import { useNavigate } from 'react-router-dom';
import {SettingsContext} from '../components/userSettingsContext';
import { useState, useEffect, forwardRef, useRef, useImperativeHandle } from "react"

import {CcStepper2, StepperNavButtons} from "../commonComponents/stepper"

import Konva from 'konva';

import axios from 'axios';

import {IconButton, Radio, Tooltip} from '@mui/material';

import {CcProgressBar, InfoToolTip, LionLoaderGradient} from '../commonComponents/generalComponents'
import {SnippetCodeViewer} from '../commonComponents/snippetGeneric'
import {CcCheckbox, InputText, InputNumber, InputURL, FileSelector, LionCombo} from '../commonComponents/inputFields'
import { LionColorPicker } from '../components/lionColorPicker';
import {ccColorDarkTeal, lionObjectsColors}  from "../components/helpersStyles";
import { GoogleFontsSelector } from '../commonComponents/helperGoogleFonts';

import { Icon as Iconify } from '@iconify/react';

import { getErrorListFromYupError, getErrorMessage, getErrorMessageForArray, snippetDataValidationSchemaSpinningWheel } from '../components/helperErrors'
import { ccColorTeal } from '../components/helpersStyles';
import { CcActionButton, CcActionButtonOutlined } from '../commonComponents/styledTexts';
import { string } from 'yup';
import { GetSnippetIdfromSnippetHtml } from '../components/helpers';


import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers';
import dayjs from 'dayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

import { lionIcons } from '../components/helpersIcons';



//const defaultColors = ["#ff8095", "#55a68c", "#a274a3", "#6dbfe8", "#e6b543", "#e6b543"];
const defaultColors = ["#6dbfe8", "#17425d", "#357e86", "#55a68c", "#17425d"];
const defaultWheelSettings = {canvasWidth: 500, canvasHeight: 500, backgroundColor: '#fff', backgroundMakeTransparent: false, backgroundImageDataUrl: '',
                              radius: 225, centerX: 250, centerY:250, sliceStrokeColor: '#eee', sliceStrokeWidth: 5, outerBorderColor: '#777', outerBorderStrokeWidth: 5,
                              textStartHeight: 225 * .8, kernel: {radius: 40, color: '#eee', strokeColor: '#777', strokeWidth: 5},
                              pointer: {shape: 'house', color: '#357e86', strokeColor: '#000', strokeWidth: 0, scaleFactor: 1},
                              expiry: {expirySettingsActive: false, expiryDate: dayjs().add(24, 'hour').toJSON(), expiryTimezoneId: 'Europe/London', imageB64: '', expiryHref: ''},
                              intro: {useIntro: false, renderInPreview: false, color: '#000', opacity: 1, digitsColor: '#fff', digitsSize: 64, digitsFont: 'Roboto', finalText: 'GO', digitsPosX: undefined, digitsPosY: undefined},
                              slices: [{color: defaultColors[0], textColor: '#fff', fName: 'Roboto', fSize: 18, text: 'slice 1', subtitleColor: '#fff', subtitleFName: 'Roboto', subtitleFSize: 14, subtitle: 'sub 1', heightBetweenTitleAndSubtitle: 10, titleLineHeight: 1.2, subTitleLineHeight: 1.2, titleFontWeight: 400, subtitleFontWeight:400, isDefault: true, notUsed: false, href: '', mapping: '', addIcon: false, icon: {b64: '', xml: ''}},
                                      {color: defaultColors[1], textColor: '#fff', fName: 'Roboto', fSize: 18, text: 'SO CLOSE', subtitleColor: '#fff', subtitleFName: 'Roboto', subtitleFSize: 14, subtitle: '', heightBetweenTitleAndSubtitle: 10, titleLineHeight: 1.2, subTitleLineHeight: 1.2, titleFontWeight: 400, subtitleFontWeight:400, isDefault: false, notUsed: false, href: '', mapping: '', addIcon: true, icon: {b64: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAADw0lEQVRoQ+2ZW4hNURjH57hrCFEuzYh4whQPouFhakITmqFcSlIYiQkPM6iZNJmiUZORNA8jD3IZeeBhXBpkoiiX8iBPNJhEksg1t+P31T7aZ585e39r73XOnFNWfa1z+dZ//X9rnbPW2nvHCvK8xPLcf0HGAOLxeBWDc5b4TayMxWJdmRisjABgfixme4nhjunP1EVAfLQNkSmAZozu9phtAmBfzgMw+qMw+do1+gnPMgsTgPhiE8L6DADQhMGGNCbrATiQswCYL8TcG2JEGpMf+HwiEN9tQVidAQBk5GUG/EotAC05B4D5Yc5vf3SAuXd8PwmInzYgrM0AAHUYOqQ0VQPAMWWub5oVAGf0Zd0fpzQlq1QxELLJRSq2AHbg4oihk2oAjhu2SUmPDMDoD0b1hawuhmZekj8FiLhhu6T0SACYn4zaBmJ/SBOyW3cAIT+/UMUXAINDUJ1KTCOmO7W8lpDPh4bqNbWR7As9xFPimSd6/FasfwDOJlRN41kuo8WWDEaVkZ9bAu4WQKcSgm6Ac3y4OmpPWWrfBsQ26csNIBuMHIPzofQCIP+/JAC5+FibD+7x2A7AFi+AHAFuErNzHOI+/soB+JQEIG/4I4+kukHMzVGIO/ha7L6mSFlGndVIrl9LcwyiGz8V3qN4n/uAc7a5QoOyHIG4ho9lmP/h9ZN2I3M2sU4aLOpniEv0X4X5X335CNqJB9Hocj9CiPlKv1Nr4FmImRCIi8TSLM/EBfpbFXTkDgRwVqeB1OeJFVmC6KCfdZj/E9SfCsCBGEB9msj0ZncS43LCVRU1gAMxn/quSjl80hwAHmmbmwJsRrhdKx4yb737tBmkYQrQiuDOINGI3zcDsFerYQpwHeFyrXjIvE4AlmvbmgLIXbfxWvGQec8BkKs9VVEDsB+MQfG9SjV6UiEQXzUyJgBlCMpxOxtlHgD3NB2ZANQgeFQjaiFnEwAnNDomAG0IbtWIunLkiYxsgHKdYVJaAKjVNDABuI3gQo0oOd+c2Tro5NdTbycSj5yCZLoAWBKUJN+bAMgTFrn/71fkjrPcLmzEwFt3IouA3LlrJDYSckD0K69oX2QNgM5FzO/umRy6zhDyBEbu4aQtaMkSKU9p1gQMoGolUs0AncpFTbrHpHLRswfjTzQjlshBs4TX8jCwIk27UjQDz11agJl08tjTUTfv6+jkgYlxby4gCxwQqd2lBG1vnyldqQCkFR0dptpFPCQaEL8axXgfIJV8JnfbZhCt6KseQ6kBbJq1qfUfwOZohtHK+xn4C9D3EECck4MHAAAAAElFTkSuQmCC', xml: '<svg id="slice1svg3" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24"><path fill="#ccc" d="m8.243 7.34l-6.38.925l-.113.023a1 1 0 0 0-.44 1.684l4.622 4.499l-1.09 6.355l-.013.11a1 1 0 0 0 1.464.944l5.706-3l5.693 3l.1.046a1 1 0 0 0 1.352-1.1l-1.091-6.355l4.624-4.5l.078-.085a1 1 0 0 0-.633-1.62l-6.38-.926l-2.852-5.78a1 1 0 0 0-1.794 0z"/></svg>'}},
                                      {color: defaultColors[2], textColor: '#fff', fName: 'Roboto', fSize: 18, text: 'slice 3', subtitleColor: '#fff', subtitleFName: 'Roboto', subtitleFSize: 14, subtitle: 'sub 3', heightBetweenTitleAndSubtitle: 10, titleLineHeight: 1.2, subTitleLineHeight: 1.2, titleFontWeight: 400, subtitleFontWeight:400, isDefault: false, notUsed: false, href: '', mapping: '', addIcon: false, icon: {b64: '', xml: ''}},
                                      {color: defaultColors[3], textColor: '#fff', fName: 'Roboto', fSize: 18, text: 'slice 4', subtitleColor: '#fff', subtitleFName: 'Roboto', subtitleFSize: 14, subtitle: 'sub 4', heightBetweenTitleAndSubtitle: 10, titleLineHeight: 1.2, subTitleLineHeight: 1.2, titleFontWeight: 400, subtitleFontWeight:400, isDefault: false, notUsed: false, href: '', mapping: '', addIcon: false, icon: {b64: '', xml: ''}},
                                      {color: defaultColors[4], textColor: '#fff', fName: 'Roboto', fSize: 18, text: 'slice 5', subtitleColor: '#fff', subtitleFName: 'Roboto', subtitleFSize: 14, subtitle: 'sub 5', heightBetweenTitleAndSubtitle: 10, titleLineHeight: 1.2, subTitleLineHeight: 1.2, titleFontWeight: 400, subtitleFontWeight:400, isDefault: false, notUsed: false, href: '', mapping: '', addIcon: false, icon: {b64: '', xml: ''}},
                                      ]
}


const getTextWidth = (text, font) => {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');

  context.font = font || getComputedStyle(document.body).font;

  return context.measureText(text).width;
}
const getTextMeasure = (text, font) => {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');

  context.font = font || getComputedStyle(document.body).font;

  return context.measureText(text);
}

const SvgSelector = (props) => {
  /*
props:

onChange: 

*/

const [selectedSvgId, setSelectedSvgId] = useState('')

const [svgPathStyles, setSvgPathStyles] = useState([])
const [svgSize, setSvgSize] = useState({width: 0, height: 0})

const svgDisplayAreaRef = useRef(null);
const svgGalleryAreaRef = useRef(null);


useEffect(() => {
  if (props.pointerXml && props.pointerXml.length > 0) {
    const parser = new DOMParser();
    const svgDocument = parser.parseFromString(props.pointerXml, "image/svg+xml");
    const svgElement = svgDocument.documentElement;
    setSelectedSvgId(svgElement.getAttribute("id"))
    cloneSvg(svgElement.getAttribute("id"), svgElement)
  }
  else {
    if (props.isNew) {
      setSelectedSvgId(`${props.idPrefix}svg1`);
      cloneSvg(`${props.idPrefix}svg1`)  
    }
  }

}, [props.pointerXml])



const svgToPng = () => {
  return new Promise((resolve, reject) => {
  //const svgDisplayArea = document.getElementById('svgDisplayArea')
  const svgDisplayArea = svgDisplayAreaRef.current
 
  const svg = svgDisplayArea.getElementsByTagName("svg")[0]

    // Extract SVG content as a string
    const svgString = new XMLSerializer().serializeToString(svg);

    // Convert SVG string to a data URL
    const svgDataUrl = `data:image/svg+xml;base64,${btoa(svgString)}`;

    // Create a canvas element
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    // Set canvas size to match SVG dimensions
    const width = svg.getAttribute("width");
    const height = svg.getAttribute("height");
    canvas.width = width;
    canvas.height = height;

    // Create an Image object
    const img = new Image();
    img.onload = function () {
      // Draw the SVG onto the canvas
      context.drawImage(img, 0, 0);

      // Convert the canvas content to an image data URL
      const imageDataUrl = canvas.toDataURL("image/png");
      resolve({b64: imageDataUrl, xml: svgString})
}
img.src = svgDataUrl;
  })
}


const handleEditPathStyle = async (index, propName, propValue) => {
  //const svgDisplayArea = document.getElementById('svgDisplayArea')
  const svgDisplayArea = svgDisplayAreaRef.current
 
  const paths = svgDisplayArea.getElementsByTagName("path")
  paths[index].setAttribute(propName, propValue)
  //console.log(paths)
  const newPathStyles = [...svgPathStyles]
  newPathStyles[index] = {...svgPathStyles[index], [propName]: propValue}
  setSvgPathStyles(newPathStyles)

  if (props.onChange) {
    const svgInfo = await svgToPng();
    props.onChange(svgInfo)
  }

}

const handleChangeSvgSize = async (incr) => {
  //const svgDisplayArea = document.getElementById('svgDisplayArea')
  const svgDisplayArea = svgDisplayAreaRef.current
 
  const svg = svgDisplayArea.getElementsByTagName("svg")
  const newWidth = parseInt(svg[0].getAttribute("width"),10) + incr
  const newHeight = parseInt(svg[0].getAttribute("height"),10) + incr

  svg[0].setAttribute("width", newWidth)
  svg[0].setAttribute("height", newHeight)
  setSvgSize({width: newWidth, height: newHeight})

  if (props.onChange) {
    const svgInfo = await svgToPng();
    props.onChange(svgInfo)
  }

}
const cloneSvg = async (svgId, svgElement) => {
  //copy the svg tag with svgId and paste it into the pointer customisation area
  //const svg = svgElement ? svgElement : document.getElementById(svgId);
  const svg = svgElement ? svgElement : document.getElementById(svgId);
  let newSvg = svg.cloneNode(true);
  //const svgDisplayArea = document.getElementById('svgDisplayArea')
  const svgDisplayArea = svgDisplayAreaRef.current
  svgDisplayArea.replaceChildren(newSvg);
  setSvgSize({width: newSvg.getAttribute('width'), height: newSvg.getAttribute('height')})

  const paths = newSvg.getElementsByTagName("path")

  const newPathStyles = []
  //console.log(paths)
  for (let i =0; i<paths.length; i+=1) {
    const computedStyle = window.getComputedStyle(paths[i]);

    const fill = computedStyle.fill;
    const stroke = computedStyle.stroke;
    newPathStyles.push({fill: rgbToHex(fill), stroke: rgbToHex(stroke),})  
  }
  //console.log(newPathStyles)
  setSvgPathStyles(newPathStyles)

  if (props.onChange) {
    const svgInfo = await svgToPng();
    props.onChange(svgInfo)
  }

}

const rgbToHex = (rgb) => {
  try {
    return `#${rgb.match(/\d+/g).map(x => (+x).toString(16).padStart(2, "0")).join("")}`;
  }
  catch (e) {
    return rgb
  }
}


return   <div className=''>
          <div className='text-center'>Select an icon</div>
          <div ref={svgGalleryAreaRef} className='flex flex-row flex-wrap gap-4 h-[290px] overflow-auto'>
            <div className={`${selectedSvgId === props.idPrefix.concat('svg1') ? 'bg-ccColorLightTeal' :''} rounded p-1 cursor-pointer w-[136px] h-[136px] hover:bg-ccColorDarkTeal`}
                onClick={() => {setSelectedSvgId(props.idPrefix.concat('svg1')); cloneSvg(props.idPrefix.concat('svg1'))}}
                >
              <div className='bg-slate-200 rounded w-32 h-32 flex items-center justify-center'>
              <svg id={`${props.idPrefix}svg1`} xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24"><path fill="#fbbc3d" d="m5.825 21l1.625-7.025L2 9.25l7.2-.625L12 2l2.8 6.625l7.2.625l-5.45 4.725L18.175 21L12 17.275z"/></svg>
              </div>
            </div>
            <div className={`${selectedSvgId === props.idPrefix.concat('svg2') ? 'bg-ccColorLightTeal' :''} rounded p-1 cursor-pointer w-[136px] h-[136px] hover:bg-ccColorDarkTeal`}
                onClick={() => {setSelectedSvgId(props.idPrefix.concat('svg2')); cloneSvg(props.idPrefix.concat('svg2'))}}
                >
              <div className='bg-slate-200 rounded w-32 h-32 flex items-center justify-center'>
                <svg id={`${props.idPrefix}svg2`} xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24"><g fill="none"><path fill="#fbbc3d" d="m12 2l3.104 6.728l7.358.873l-5.44 5.03l1.444 7.268L12 18.28L5.534 21.9l1.444-7.268L1.538 9.6l7.359-.873z" /><path stroke="#ea8c44" stroke-linejoin="round" stroke-width="2" d="m12 2l3.104 6.728l7.358.873l-5.44 5.03l1.444 7.268L12 18.28L5.534 21.9l1.444-7.268L1.538 9.6l7.359-.873z"/></g></svg>
              </div>
            </div>
            <div className={`${selectedSvgId === props.idPrefix.concat('svg3') ? 'bg-ccColorLightTeal' :''} rounded p-1 cursor-pointer w-[136px] h-[136px] hover:bg-ccColorDarkTeal`}
                onClick={() => {setSelectedSvgId(props.idPrefix.concat('svg3')); cloneSvg(props.idPrefix.concat('svg3'))}}
                >
              <div className='bg-slate-200 rounded w-32 h-32 flex items-center justify-center'>
                <svg id={`${props.idPrefix}svg3`} xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24"><path fill="#fbbc3d" d="m8.243 7.34l-6.38.925l-.113.023a1 1 0 0 0-.44 1.684l4.622 4.499l-1.09 6.355l-.013.11a1 1 0 0 0 1.464.944l5.706-3l5.693 3l.1.046a1 1 0 0 0 1.352-1.1l-1.091-6.355l4.624-4.5l.078-.085a1 1 0 0 0-.633-1.62l-6.38-.926l-2.852-5.78a1 1 0 0 0-1.794 0z"/></svg>
              </div>
            </div>
            <div className={`${selectedSvgId === props.idPrefix.concat('svg4') ? 'bg-ccColorLightTeal' :''} rounded p-1 cursor-pointer w-[136px] h-[136px] hover:bg-ccColorDarkTeal`}
                onClick={() => {setSelectedSvgId(props.idPrefix.concat('svg4')); cloneSvg(props.idPrefix.concat('svg4'))}}
                >
              <div className='bg-slate-200 rounded w-32 h-32 flex items-center justify-center'>
                <svg id={`${props.idPrefix}svg4`} xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24"><path fill="currentColor" d="M20 20H8a4.92 4.92 0 0 0 1-3v-3h6a1 1 0 0 0 0-2H9V8.89a4.89 4.89 0 0 1 9.13-2.44a1 1 0 0 0 1.37.36a1 1 0 0 0 .37-1.36A6.9 6.9 0 0 0 7 8.89V12H4a1 1 0 0 0 0 2h3v3a3 3 0 0 1-3 3a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2"/></svg>
              </div>
            </div>
            <div className={`${selectedSvgId === props.idPrefix.concat('svg5') ? 'bg-ccColorLightTeal' :''} rounded p-1 cursor-pointer w-[136px] h-[136px] hover:bg-ccColorDarkTeal`}
                onClick={() => {setSelectedSvgId(props.idPrefix.concat('svg5')); cloneSvg(props.idPrefix.concat('svg5'))}}
                >
              <div className='bg-slate-200 rounded w-32 h-32 flex items-center justify-center'>
                <svg id={`${props.idPrefix}svg5`} xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 14 14"><path fill="currentColor" fill-rule="evenodd" d="M13.463 9.692C13.463 12.664 10.77 14 7 14S.537 12.664.537 9.713c0-3.231 1.616-4.868 4.847-6.505L4.24 1.077A.7.7 0 0 1 4.843 0H9.41a.7.7 0 0 1 .603 1.023L8.616 3.208c3.23 1.615 4.847 3.252 4.847 6.484M8.488 5.615c.152.053.326.13.438.223a.5.5 0 0 1-.64.77l-.004-.005l.005.004l.003.003l.007.006s-.003 0-.009-.004a1.8 1.8 0 0 0-.536-.142c-.316-.03-.615.03-.836.25c-.117.117-.194.312-.222.652a5 5 0 0 0-.01.536h1.483a.5.5 0 1 1 0 1h-1.47a3 3 0 0 1-.173.974l-.028.068H8.75a.5.5 0 0 1 0 1h-3.5a.5.5 0 0 1-.158-.974c.29-.097.421-.253.5-.455a2 2 0 0 0 .104-.613H5.25a.5.5 0 0 1 0-1h.433a6 6 0 0 1 .015-.619c.035-.425.144-.91.511-1.276c.509-.508 1.154-.585 1.64-.538c.245.024.466.08.64.14Z" clip-rule="evenodd"/></svg>
              </div>
            </div>
            <div className={`${selectedSvgId === props.idPrefix.concat('svg6') ? 'bg-ccColorLightTeal' :''} rounded p-1 cursor-pointer w-[136px] h-[136px] hover:bg-ccColorDarkTeal`}
                onClick={() => {setSelectedSvgId(props.idPrefix.concat('svg6')); cloneSvg(props.idPrefix.concat('svg6'))}}
                >
              <div className='bg-slate-200 rounded w-32 h-32 flex items-center justify-center'>
                <svg id={`${props.idPrefix}svg6`} xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2S2 6.477 2 12s4.477 10 10 10"/><path d="M15 9c0-1.6-1.333-2-2-2s-2 .4-2 2v3m0 0v2c0 .667-.4 2-2 2h6m-4-4h2m-2 0H9"/></g></svg>
              </div>
            </div>

            <div className={`${selectedSvgId === props.idPrefix.concat('svg7') ? 'bg-ccColorLightTeal' :''} rounded p-1 cursor-pointer w-[136px] h-[136px] hover:bg-ccColorDarkTeal`}
                onClick={() => {setSelectedSvgId(props.idPrefix.concat('svg7')); cloneSvg(props.idPrefix.concat('svg7'))}}
                >
              <div className='bg-slate-200 rounded w-32 h-32 flex items-center justify-center'>
                <svg id={`${props.idPrefix}svg7`} xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24"><path fill="currentColor" d="M7 15h2c0 1.08 1.37 2 3 2s3-.92 3-2c0-1.1-1.04-1.5-3.24-2.03C9.64 12.44 7 11.78 7 9c0-1.79 1.47-3.31 3.5-3.82V3h3v2.18C15.53 5.69 17 7.21 17 9h-2c0-1.08-1.37-2-3-2s-3 .92-3 2c0 1.1 1.04 1.5 3.24 2.03C14.36 11.56 17 12.22 17 15c0 1.79-1.47 3.31-3.5 3.82V21h-3v-2.18C8.47 18.31 7 16.79 7 15"/></svg>
              </div>
            </div>
            <div className={`${selectedSvgId === props.idPrefix.concat('svg8') ? 'bg-ccColorLightTeal' :''} rounded p-1 cursor-pointer w-[136px] h-[136px] hover:bg-ccColorDarkTeal`}
                onClick={() => {setSelectedSvgId(props.idPrefix.concat('svg8')); cloneSvg(props.idPrefix.concat('svg8'))}}
                >
              <div className='bg-slate-200 rounded w-32 h-32 flex items-center justify-center'>
                <svg id={`${props.idPrefix}svg8`} xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24"><path fill="currentColor" d="M11.25 7.847c-.936.256-1.5.975-1.5 1.653s.564 1.397 1.5 1.652zm1.5 5.001v3.304c.936-.255 1.5-.974 1.5-1.652s-.564-1.397-1.5-1.652"/><path fill="currentColor" fill-rule="evenodd" d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2s10 4.477 10 10M12 5.25a.75.75 0 0 1 .75.75v.317c1.63.292 3 1.517 3 3.183a.75.75 0 0 1-1.5 0c0-.678-.564-1.397-1.5-1.653v3.47c1.63.292 3 1.517 3 3.183s-1.37 2.891-3 3.183V18a.75.75 0 0 1-1.5 0v-.317c-1.63-.292-3-1.517-3-3.183a.75.75 0 0 1 1.5 0c0 .678.564 1.397 1.5 1.652v-3.469c-1.63-.292-3-1.517-3-3.183s1.37-2.891 3-3.183V6a.75.75 0 0 1 .75-.75" clip-rule="evenodd"/></svg>
              </div>
            </div>
            <div className={`${selectedSvgId === props.idPrefix.concat('svg9') ? 'bg-ccColorLightTeal' :''} rounded p-1 cursor-pointer w-[136px] h-[136px] hover:bg-ccColorDarkTeal`}
                onClick={() => {setSelectedSvgId(props.idPrefix.concat('svg9')); cloneSvg(props.idPrefix.concat('svg9'))}}
                >
              <div className='bg-slate-200 rounded w-32 h-32 flex items-center justify-center'>
                <svg id={`${props.idPrefix}svg9`} xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 14 14"><path fill="currentColor" fill-rule="evenodd" d="M13.463 9.692C13.463 12.664 10.77 14 7 14S.537 12.664.537 9.713c0-3.231 1.616-4.868 4.847-6.505L4.24 1.077A.7.7 0 0 1 4.843 0H9.41a.7.7 0 0 1 .603 1.023L8.616 3.208c3.23 1.615 4.847 3.252 4.847 6.484M7.625 4.887a.625.625 0 1 0-1.25 0v.627a1.74 1.74 0 0 0-.298 3.44l1.473.322a.625.625 0 0 1-.133 1.236h-.834a.625.625 0 0 1-.59-.416a.625.625 0 1 0-1.178.416a1.88 1.88 0 0 0 1.56 1.239v.636a.625.625 0 1 0 1.25 0v-.636a1.876 1.876 0 0 0 .192-3.696l-1.473-.322a.49.49 0 0 1 .105-.97h.968a.62.62 0 0 1 .59.416a.625.625 0 0 0 1.178-.417a1.87 1.87 0 0 0-1.56-1.238z" clip-rule="evenodd"/></svg>
              </div>
            </div>

          </div>

          <div className='text-center mt-1'>Customise icon</div>
          <div className='flex flex-row items-center'>
            <div id="svgDisplayArea" ref={svgDisplayAreaRef}>
            </div>
            <div>
              <div className='flex flex-row gap-x-1'>
                <IconButton sx={{color: ccColorDarkTeal, ":hover": {backgroundColor: '#8ED2D7'}}} onClick={() => handleChangeSvgSize(+1)} ><Iconify icon="icomoon-free:enlarge" width="32" height="32" /></IconButton>
                <IconButton sx={{color: ccColorDarkTeal, ":hover": {backgroundColor: '#8ED2D7'}}} onClick={() => handleChangeSvgSize(-1)} ><Iconify icon="lets-icons:reduce" width="32" height="32" /></IconButton>
              </div>
              <div className='flex flex-row gap-x-1 mt-1'>
                <div>Size</div>
                <div className='bg-ccColorYellow rounded text-sm font-semibold p-1'>{`${svgSize.width} x ${svgSize.height} px`}</div>
              </div>
            </div>
          </div>
          <div className='grid grid-cols-3 w-[740px] max-h-80 overflow-auto mt-2 gap-y-8'>
            {svgPathStyles.map((s, index) => <div className='flex flex-col gap-y-2'>
              <div className='flex flex-row items-center gap-x-2'>
                <div className='min-w-[88px] max-w-[96px]'>Fill colour {index}</div>
                <LionColorPicker color={s.fill}
                    //onChange={(color) => handleEditPathStyle(index, 'fill', color)}
                    onSelected={(color) => handleEditPathStyle(index, 'fill', color)}
                />

              </div>
              <div className='flex flex-row items-center gap-x-2'>
                <div className='min-w-[88px] max-w-[96px]'>Stroke {index}</div>
                <LionColorPicker color={s.stroke}
                    onSelected={(color) => handleEditPathStyle(index, 'stroke', color)}
                    />

              </div>
            </div>)}
          </div>       
  </div>

}


const SpinningWheelElementManager = forwardRef((props, ref) => {
  /*
  props:
  templateId: (must be provided for new )
  snippetInfo: (must be provided for edits )

  onChange: returns all the snippet info
  */


  const spinDuration = 3; // Seconds
  //const numSlices = 5;

  //const {settings, setSettings} = useContext(SettingsContext);

  const [snippetName, setSnippetName] = useState('')
  const [snippetDesc, setSnippetDesc] = useState('')
  const [wheelSettings, setWheelSettings] = useState({})
  const [fonts, setFonts] = useState([])
  const [bgImageSize, setBgImageSize] = useState({width: 0, height: 0})

  const canvasRef = useRef(null);
  const svgSelectorRef = useRef();

  const [doNotPropagate, setDoNotPropagate] = useState(true);
  

  useEffect(() => {
    //console.log(props.snippetInfo)
    
    if (props.snippetInfo) { //we are in edit
      setSnippetName(props.snippetInfo.snippetName)
      setSnippetDesc(props.snippetInfo.snippetDesc)
      if (props.snippetInfo.wheelSettings) {
        setWheelSettings(props.snippetInfo.wheelSettings)
        initKonva(props.snippetInfo.wheelSettings)
      }
    }
    else {
      initKonva(wheelSettings)      
    }
    if (fonts.length === 0) getFonts()
    
  }, [props.snippetInfo])


  
  useEffect(() => {
    initKonva(wheelSettings)
    //if (!doNotPropagate && props.onChange) props.onChange(prepareDataToPost('wheelSettings', wheelSettings))
    //setDoNotPropagate(false)
    //console.log(wheelSettings)

  },[wheelSettings])



  useImperativeHandle(ref, () => ({
    async askFrames(index) {
      const result =  getAnimationFrames(index);
      return result;
    },
  }))


  const getFonts = async () => {
    try {
      let url = `${process.env.REACT_APP_LION_API_URL}/WebPages/GoogleFontsList`;

      const response = await axios.get(url);
      setFonts(response.data);
      
    } catch (error) {
      //console.log(error);
    }

  }

  const prepareDataToPost = (updatePropName, updatePropValue) => {
    const result = {snippetId: 0, snippetName: '', snippetDesc: '', 
    labels: [{labelId: 0, labelName: ''}], href: '',
    snippetTypeId: 16,
    filters: [], orderBy: [],
    dataConnectionId: 0, templateId: 0, dataConnectionInfo: {},
    wheelSettings: wheelSettings};

    result.snippetName = snippetName;
    result.snippetDesc = snippetDesc;

    if (updatePropName) {
      result[updatePropName] = updatePropValue;
    }
      //console.log(result)
      return result;
  }

  const handleSnippetNameChange = (newValue) => {
    setSnippetName(newValue)
    if (props.onChange) props.onChange(prepareDataToPost('snippetName', newValue))
  }
  const handleSnippetDescChange = (newValue) => {
    setSnippetDesc(newValue)
    if (props.onChange) props.onChange(prepareDataToPost('snippetDesc', newValue))
  }

    
const konvaAddSliceIcon = (wheelSettings, sliceIndex, iconStartHeight) => {

      return new Promise((resolve, reject) => {
        const imageObj = new Image();
        imageObj.src = wheelSettings.slices[sliceIndex].icon.b64;

        imageObj.onload = function () {
          const konvaImage = new Konva.Image({
            x: -imageObj.width/2,
            y: -iconStartHeight,
            image: imageObj,
            width: imageObj.width,
            height: imageObj.height,
          });

          resolve(konvaImage)
          //wheel.add(konvaImage);
          //rotateTextInGroupAroundPoint(konvaImage, sliceAngle * i, wheelSettings.centerX, wheelSettings.centerY)

          //layer.draw();
        };

      })

}  

const initKonva = async (wheelSettings,  introFrame) => {
  //introFrame: when specified it shows the intro frame on top of the wheel
  //            when -1 it forces not to draw the intro frame, this is useful because the intro frame can be generate also when the wheelSettings.intro.renderInPreview flag is true

  //console.log(wheelSettings)
    if (wheelSettings.slices === undefined) return;

    //const wheel = new Konva.Group({ id: "wheelGroup", x: wheelSettings.canvasWidth / 2, y: wheelSettings.canvasHeight / 2, draggable: true, });
    const wheel = new Konva.Group({ id: "wheelGroup", x: wheelSettings.centerX, y: wheelSettings.centerY, draggable: true, });
    wheel.on('mouseover', (e) => {
      document.body.style.cursor = 'pointer';
    });
    wheel.on('mouseout', (e) => {
      document.body.style.cursor = 'default';
    });
    wheel.on('dragend', (e) => {
      updateWheelCenter(e.target.attrs.x, e.target.attrs.y)
    })  
    wheel.on('dragmove', (e) => {
      //console.log(e.target.attrs)
      initKonvaWheelPointer(layer, e.target.attrs.x, e.target.attrs.y)
    })  
  


    const stage = new Konva.Stage({
        container: 'canvasContainer',
    });
    canvasRef.current = stage;


    const layer = new Konva.Layer();

    layer.add(wheel);
    stage.add(layer);

    const res = await updateCanvas(layer)

    const sliceAngle = (360 / wheelSettings.slices.length)
    const startAngle = -90 - sliceAngle/2 //the startAngle is used as an offset so that the first slice starts on top



    for (let i = 0; i < wheelSettings.slices.length; i++) {
        const wedge = new Konva.Wedge({
            x: 0,
            y: 0,
            radius: wheelSettings.radius,
            angle: sliceAngle,
            fill: wheelSettings.slices[i].color,
            rotation: (i * sliceAngle) + startAngle,
            stroke: wheelSettings.sliceStrokeColor,
            strokeWidth: wheelSettings.sliceStrokeWidth,
        });
        wheel.add(wedge);
        let finalHeight = renderText(wheelSettings.textStartHeight, i, wheelSettings.slices[i])
        finalHeight -= wheelSettings.slices[i].heightBetweenTitleAndSubtitle;
        let iconStartHeight = finalHeight
        finalHeight = renderText(finalHeight, i, wheelSettings.slices[i], true)
        if (wheelSettings.slices[i].subtitle.length > 0) iconStartHeight = finalHeight;

        
        if (wheelSettings.slices[i].addIcon) {

          const konvaImage = await konvaAddSliceIcon(wheelSettings, i, iconStartHeight);
          wheel.add(konvaImage);
          rotateTextInGroupAroundPoint(konvaImage, sliceAngle * i, wheelSettings.centerX, wheelSettings.centerY)

          layer.draw();

        }


    }

    //draw outer border
    var outerBorder = new Konva.Circle({
      x: 0,
      y: 0,
      radius: wheelSettings.radius + wheelSettings.sliceStrokeWidth/2 + wheelSettings.outerBorderStrokeWidth/2,
      //fill: 'red',
      stroke: wheelSettings.outerBorderColor,
      strokeWidth: wheelSettings.outerBorderStrokeWidth,
    });
    wheel.add(outerBorder)

    //draw kernel
    var kernel = new Konva.Circle({
      x: 0,
      y: 0,
      radius: wheelSettings.kernel.radius,
      fill: wheelSettings.kernel.color,
      stroke: wheelSettings.kernel.strokeColor,
      strokeWidth: wheelSettings.kernel.strokeWidth,
    });
    wheel.add(kernel)


    initKonvaWheelPointer(layer, wheelSettings.centerX, wheelSettings.centerY)


    if (introFrame === undefined && wheelSettings.intro && wheelSettings.intro.renderInPreview) {
      generateIntroFrame(0)
    }

    
    if (introFrame !== undefined && introFrame !== -1) {
      generateIntroFrame(introFrame)
    }
  
}
const initKonvaWheelPointer = (layer, wheelCenterX, wheelCenterY) => {
  if (wheelSettings.pointer === undefined) return;

  const oldPointer = canvasRef.current.find('#wheelPointer')[0]
  if (oldPointer) oldPointer.destroy()

  let points = []
  const pointerHeight = 45

  const pointerY = wheelCenterY - wheelSettings.radius - pointerHeight/2
  if (wheelSettings.pointer.shape === 'triangle') {
    points = [wheelCenterX - 25, pointerY, wheelCenterX + 25, pointerY, wheelCenterX, pointerY + pointerHeight]
  }
  if (wheelSettings.pointer.shape === 'house') {
    points = [wheelCenterX - 25, pointerY + 15, wheelCenterX - 25, pointerY, wheelCenterX + 25, pointerY, wheelCenterX + 25, pointerY +15, wheelCenterX, pointerY + pointerHeight]
  }

  //const pointerY = - wheelSettings.radius - pointerHeight/2
  const scaleFactor = wheelSettings.pointer.scaleFactor ?? 1
  const anchorX = wheelCenterX;
  const anchorY = pointerY +22;


  const scaledPoints = points.map((p, i) => 
    i % 2 === 0 
      ? anchorX + (p - anchorX) * scaleFactor
      : anchorY + (p - anchorY) * scaleFactor
  );


  var pointer = new Konva.Line({
    id: 'wheelPointer',
    //points: [- 20, pointerY, 20, pointerY, 0, pointerY + pointerHeight],
    //points: points,
    points: scaledPoints,
    fill: wheelSettings.pointer.color,
    stroke: wheelSettings.pointer.strokeColor,
    strokeWidth: wheelSettings.pointer.strokeWidth,
    closed: true,
    lineJoin: 'round',
  });
  layer.add(pointer)

}

const degToRad = (deg) => {
  return deg * Math.PI / 180;
}




function rotateTextAroundPoint(textNode, angle, pivotX, pivotY) {
  // Convert angle from degrees to radians
  let rad = (Math.PI / 180) * angle;

  // Get current position
  let x = textNode.x();
  let y = textNode.y();

  // Calculate new position after rotation
  let newX = 
      Math.cos(rad) * (x - pivotX) - Math.sin(rad) * (y - pivotY) + pivotX;
  let newY = 
      Math.sin(rad) * (x - pivotX) + Math.cos(rad) * (y - pivotY) + pivotY;

  // Apply new position and rotation
  textNode.position({ x: newX, y: newY });
  textNode.rotation(textNode.rotation() + angle);
}
function rotateTextInGroupAroundPoint(textNode, angle, pivotX, pivotY) {
  let group = textNode.getParent(); // Get the parent group

  if (!group) {
      console.error("Text node must be inside a group!");
      return;
  }

  // Convert angle from degrees to radians
  let rad = (Math.PI / 180) * angle;

  // Get the absolute position of the text node
  let absPos = textNode.getAbsolutePosition();

  // Compute new position after rotation (global transformation)
  let newX =
      Math.cos(rad) * (absPos.x - pivotX) - Math.sin(rad) * (absPos.y - pivotY) + pivotX;
  let newY =
      Math.sin(rad) * (absPos.x - pivotX) + Math.cos(rad) * (absPos.y - pivotY) + pivotY;

  // Convert new absolute position to group's local coordinates
  let inverseTransform = group.getTransform().copy().invert();
  let newLocalPos = inverseTransform.point({ x: newX, y: newY });

  // Apply new position and rotation to the text
  textNode.position(newLocalPos);
  textNode.rotation(textNode.rotation() + angle);
}



const renderText = (startHeight, sliceIndex, slice, renderSubtitle) => {
  //if renderSubtitle is true we only render the subtitle
  //otherwise we render the title

  if (wheelSettings.slices === undefined) return;

  //we want to render the text in max 3 lines
  let words = slice.text.split(' ');
  if (renderSubtitle) words = slice.subtitle.split(' ')
  words.push("") //workaround - we add an empty word so it works better

  let lines = [];
  let numLinesUsed = 0;
  let currentLine = '';
  const safetyWidthConstraint = 20;

  const sliceAngle = (360 / wheelSettings.slices.length)

  //console.log(startHeight)
  //const widthAtCurrentHeight = startHeight * Math.tan(degToRad(sliceAngle/2))
  let widthAtCurrentHeight = startHeight / Math.cos(degToRad(sliceAngle/2))
  
  //console.log(widthAtCurrentHeight)
  currentLine = words[0]
  let currentLineMinusOneWord = ''
  let previousTextWidth = 0;
  for (let i = 1; i < words.length; i++) {
    let textWidth = 0;
    if (renderSubtitle) textWidth = getTextWidth(currentLine, `${slice.subtitleFontWeight ? slice.subtitleFontWeight : 400} ${slice.subtitleFSize}px ${slice.subtitleFName}`);
    else textWidth = getTextWidth(currentLine, `${slice.titleFontWeight ? slice.titleFontWeight : 400} ${slice.fSize}px ${slice.fName}`);
    //console.log(currentLine)
    //console.log(textWidth)
    if (textWidth >= widthAtCurrentHeight - safetyWidthConstraint) {
      lines.push({txt: currentLineMinusOneWord, txtLength: previousTextWidth, availableWidth: widthAtCurrentHeight})
      currentLine = words[i-1]
      currentLineMinusOneWord = ''
      previousTextWidth = 0
      numLinesUsed += 1
      if (numLinesUsed >= 3) break;
      widthAtCurrentHeight = (startHeight - slice.fSize) / Math.cos(degToRad(sliceAngle/2))
      if (renderSubtitle) widthAtCurrentHeight = (startHeight - slice.subtitleFSize) / Math.cos(degToRad(sliceAngle/2))
      //console.log(widthAtCurrentHeight)
    }
    currentLineMinusOneWord = currentLine
    previousTextWidth = textWidth;
    currentLine += ' ' + words[i];
  }
  if (currentLine.length > 0) {
    if (renderSubtitle) lines.push({txt: currentLine, availableWidth: widthAtCurrentHeight, txtLength: getTextWidth(currentLine, `${slice.subtitleFSize}px ${slice.subtitleFName}`)})
    else lines.push({txt: currentLine, availableWidth: widthAtCurrentHeight, txtLength: getTextWidth(currentLine, `${slice.fSize}px ${slice.fName}`)})
  }

  const wheel = canvasRef.current.find('#wheelGroup')[0]


    //console.log(lines)
  //for each line we draw a konva text
  for (const l of lines) {l.txt = l.txt.trim()}

  let finalHeight = 0;
  const lineHeightPx = renderSubtitle ? slice.subtitleFSize * slice.subTitleLineHeight : slice.fSize * slice.titleLineHeight
  for (let i=0; i<lines.length; i+=1) {
    const fSize = renderSubtitle ? slice.subtitleFSize : slice.fSize
    const fName = renderSubtitle ? slice.subtitleFName : slice.fName

    
    const txtLength = getTextWidth(lines[i].txt, `${fSize}px ${fName}`)
    const text = new Konva.Text({
      //x: -(lines[i].availableWidth)/2 +(lines[i].availableWidth - lines[i].txtLength) / 2 - 6,
      //x: -(lines[i].availableWidth)/2 +(lines[i].availableWidth - txtLength) / 2 - 6,
      x: -(txtLength) / 2,
      //y: renderSubtitle ? -startHeight + slice.subtitleFSize * i : -startHeight + slice.fSize * i,
      y: -startHeight + lineHeightPx * i,
      text: lines[i].txt,
      fontSize: fSize,
      fontFamily: fName,
      fill: renderSubtitle ? slice.subtitleColor : slice.textColor,
      rotation: 0,
      fontStyle: renderSubtitle ? (slice.subtitleFontWeight ? slice.subtitleFontWeight.toString() : '400') : (slice.titleFontWeight ? slice.titleFontWeight.toString() : '400'),
    });

    finalHeight = text.attrs.y

    wheel.add(text)
    //rotateTextInGroupAroundPoint(text, sliceAngle * sliceIndex, wheelSettings.canvasWidth / 2, wheelSettings.canvasHeight / 2)
    rotateTextInGroupAroundPoint(text, sliceAngle * sliceIndex, wheelSettings.centerX, wheelSettings.centerY)
    //console.log(text.attrs)
  }

  return (finalHeight + slice.fSize) * -1 //we need to change the sign 
/*
  var redLine = new Konva.Line({
    points: [-widthAtCurrentHeight/2, -startHeight, widthAtCurrentHeight/2, -startHeight],
    stroke: 'red',
    strokeWidth: 4,
    lineCap: 'round',
    lineJoin: 'round',
  });
*/




}



const updateCanvas_Backup = (layer) => {
  //canvasRef.current.container().style.backgroundImage = `none`;
  //canvasRef.current.container().style.backgroundColor = wheelSettings.backgroundColor;  

  if (wheelSettings.backgroundImageDataUrl && wheelSettings.backgroundImageDataUrl.length > 0) {
    const img = new window.Image();
    img.src = wheelSettings.backgroundImageDataUrl;
    
    img.onload = () => {
      //console.log(img)
      const bgImage = new Konva.Image({
        image: img,
        x: 0,
        y: 0,
        //width: img.width,
        //height: img.height,
        width: wheelSettings.canvasWidth,
        height: wheelSettings.canvasHeight
      });
      layer.add(bgImage)
      bgImage.moveToBottom()
      setBgImageSize({width: img.width, height: img.height})
      //updateCanvasSize(img.width, img.height)
    }
  }
  
  if (!wheelSettings.backgroundMakeTransparent && (wheelSettings.backgroundImageDataUrl === undefined || wheelSettings.backgroundImageDataUrl.length === 0)) {
    const backgroundColor = new Konva.Rect({
      x: 0,
      y: 0,
      width: wheelSettings.canvasWidth,
      height: wheelSettings.canvasHeight,
      fill: wheelSettings.backgroundColor,
    });
    layer.add(backgroundColor)
    backgroundColor.moveToBottom()
  
  }


  canvasRef.current.width(wheelSettings.canvasWidth);
  canvasRef.current.height(wheelSettings.canvasHeight);
  canvasRef.current.container().style.width = `${wheelSettings.canvasWidth}px`;
  canvasRef.current.container().style.height = `${wheelSettings.canvasHeight}px`;
  canvasRef.current.container().style.backgroundSize = `${wheelSettings.canvasWidth}px ${wheelSettings.canvasHeight}px`;


  //document.getElementById('canvas-outline').style.width = `min(${canvasSettings.canvasWidth}px, calc(100%))`;
  //document.getElementById('canvas-outline').style.height = `min(${canvasSettings.canvasHeight}px, 400px)`;

}
const updateCanvas = (layer) => {
  canvasRef.current.width(wheelSettings.canvasWidth);
  canvasRef.current.height(wheelSettings.canvasHeight);
  canvasRef.current.container().style.width = `${wheelSettings.canvasWidth}px`;
  canvasRef.current.container().style.height = `${wheelSettings.canvasHeight}px`;
  canvasRef.current.container().style.backgroundSize = `${wheelSettings.canvasWidth}px ${wheelSettings.canvasHeight}px`;


  return new Promise((resolve, reject) => {
    if (wheelSettings.backgroundImageDataUrl && wheelSettings.backgroundImageDataUrl.length > 0) {
      const img = new window.Image();
      img.src = wheelSettings.backgroundImageDataUrl;
      
      img.onload = () => {
        const bgImage = new Konva.Image({
          image: img,
          x: 0,
          y: 0,
          width: wheelSettings.canvasWidth,
          height: wheelSettings.canvasHeight
        });
        layer.add(bgImage)
        bgImage.moveToBottom()
        setBgImageSize({width: img.width, height: img.height})
        //updateCanvasSize(img.width, img.height)
        resolve('ok')
      }
      img.onerror = (error) => {
        reject(error);
      };
    }
    
    else if (!wheelSettings.backgroundMakeTransparent && (wheelSettings.backgroundImageDataUrl === undefined || wheelSettings.backgroundImageDataUrl.length === 0)) {
      const backgroundColor = new Konva.Rect({
        x: 0,
        y: 0,
        width: wheelSettings.canvasWidth,
        height: wheelSettings.canvasHeight,
        fill: wheelSettings.backgroundColor,
      });
      layer.add(backgroundColor)
      backgroundColor.moveToBottom()
      resolve(1)
    
    }
  
  
  
  })


  //document.getElementById('canvas-outline').style.width = `min(${canvasSettings.canvasWidth}px, calc(100%))`;
  //document.getElementById('canvas-outline').style.height = `min(${canvasSettings.canvasHeight}px, 400px)`;

}

const updateWheelSettings = (propName, propValue) => {
  const newSettings = {...wheelSettings, [propName]: propValue}

  //special cases:
  //if propName is radius then we also want to change textStartHeight
  if (propName === 'radius') newSettings.textStartHeight = propValue * .8
  //setWheelSettings(newSettings)

  if (props.onChange) props.onChange(prepareDataToPost('wheelSettings', newSettings))

}
const updateWheelCenter = (x, y) => {
  const newSettings = {...wheelSettings, centerX: x, centerY: y}

  //setWheelSettings(newSettings)
  if (props.onChange) props.onChange(prepareDataToPost('wheelSettings', newSettings))

}
const updateCanvasSize = (width, height) => {
  const newSettings = {...wheelSettings, canvasWidth: width, canvasHeight: height}

  //setWheelSettings(newSettings)
  if (props.onChange) props.onChange(prepareDataToPost('wheelSettings', newSettings))

}

const updateSliceSettings = (sliceIndex, propName, propValue) => {
  const newSlicesArr = [...wheelSettings.slices]
  const newSlice = newSlicesArr[sliceIndex]
  newSlice[propName] = propValue
  newSlicesArr.splice(sliceIndex, 1, newSlice);


  //setWheelSettings({...wheelSettings, slices: newSlicesArr})
  if (props.onChange) props.onChange(prepareDataToPost('wheelSettings', {...wheelSettings, slices: newSlicesArr}))

}
const updatePointerSettings = (propName, propValue) => {
  const newPointer = {...wheelSettings.pointer, [propName]: propValue}


  //setWheelSettings({...wheelSettings, pointer: newPointer})
  if (props.onChange) props.onChange(prepareDataToPost('wheelSettings', {...wheelSettings, pointer: newPointer}))

}
const updatePointerScaleFactor = (delta) => {
  const existingScaleFactor = wheelSettings.pointer.scaleFactor ?? 1
  updatePointerSettings('scaleFactor', existingScaleFactor + delta)
}

const updateKernelSettings = (propName, propValue) => {
  const newKernel = {...wheelSettings.kernel, [propName]: propValue}
  //console.log(newKernel)

  //setWheelSettings({...wheelSettings, kernel: newKernel})
  if (props.onChange) props.onChange(prepareDataToPost('wheelSettings', {...wheelSettings, kernel: newKernel}))

}
const updateIntroSettings = (propName, propValue) => {
  const newIntro = {...wheelSettings.intro, [propName]: propValue}
  //console.log(newKernel)

  //setWheelSettings({...wheelSettings, intro: newIntro})
  if (props.onChange) props.onChange(prepareDataToPost('wheelSettings', {...wheelSettings, intro: newIntro}))
}
const updateDigitsPos_IntroSettings = (posX, posY) => {
  const newIntro = {...wheelSettings.intro, digitsPosX: Math.round(posX), digitsPosY: Math.round(posY)}
  //console.log(newKernel)

  //setWheelSettings({...wheelSettings, intro: newIntro})
  if (props.onChange) props.onChange(prepareDataToPost('wheelSettings', {...wheelSettings, intro: newIntro}))
}

const handleRemoveSlice = () => {
  const newSlicesArr = [...wheelSettings.slices]
  newSlicesArr.splice(newSlicesArr.length-1, 1,);

  setWheelSettings({...wheelSettings, slices: newSlicesArr})
  if (props.onChange) props.onChange(prepareDataToPost('wheelSettings', {...wheelSettings, slices: newSlicesArr}))

}
const handleAddSlice = () => {
  const newSlicesArr = [...wheelSettings.slices]
  const newSlice = {...wheelSettings.slices[0], isDefault: false, notUsed: false, color: defaultColors[getRandomInt(0, defaultColors.length-1)], text: 'New slice', subtitle: 'New subtitle'}
  newSlicesArr.push(newSlice)

  setWheelSettings({...wheelSettings, slices: newSlicesArr})
  if (props.onChange) props.onChange(prepareDataToPost('wheelSettings', {...wheelSettings, slices: newSlicesArr}))
  }

const playIntroAndSpin = async () => {
  let count = 0;
  await initKonva(wheelSettings, count)
  const numIntroFrames = wheelSettings.intro.finalText.length > 0 ? 4 : 3

  const interval = setInterval(async () => {
    count++;
    await initKonva(wheelSettings, count)
  
      if (count === numIntroFrames) {
          clearInterval(interval);
          await initKonva(wheelSettings, -1)
          spinWheel()
      }
  }, 1000);
  
} 

const getIntroDigitsCenter = () => {
  const textMeasure = getTextMeasure('3', `${wheelSettings.intro.digitsSize}px ${wheelSettings.intro.digitsFont}`);
  const textHeight = textMeasure.actualBoundingBoxAscent + textMeasure.actualBoundingBoxDescent;
  const textWidth = textMeasure.width

  const x = wheelSettings.canvasWidth / 2 - textWidth /2
  const y = wheelSettings.canvasHeight / 2 - textHeight /2

  return [Math.round(x), Math.round(y)]
}

const generateIntroFrame = (frameIndex) => {
  if (wheelSettings.intro === undefined) return

  const texts = [3,2,1,wheelSettings.intro.finalText]
  const text = texts[frameIndex]
  //const textMeasure = getTextMeasure(text, `${wheelSettings.intro.digitsSize}px ${wheelSettings.intro.digitsFont}`);
  //const textHeight = textMeasure.actualBoundingBoxAscent + textMeasure.actualBoundingBoxDescent;
  //const textWidth = textMeasure.width

  const [posX, posY] = getIntroDigitsCenter();

  const layer = canvasRef.current.getLayers()[0]

  var rect = new Konva.Rect({
    x: 0,
    y: 0,
    width: wheelSettings.canvasWidth,
    height: wheelSettings.canvasHeight,
    fill: wheelSettings.intro.color,
    opacity: wheelSettings.intro.opacity
  });
  layer.add(rect);


  //last intro frame: we need to center the finalText!!!
  if (frameIndex === 3) {
    const x = wheelSettings.intro.digitsPosX ?? posX
    const y = wheelSettings.intro.digitsPosY ?? posY
    const finalTextMeasure = getTextMeasure(text, `${wheelSettings.intro.digitsSize}px ${wheelSettings.intro.digitsFont}`);

    //to center the finalText we need to remember that the x position found above
    //is not the center but the center minus the text width so we need to account
    //for that offset
    const digitMeasure = getTextMeasure('3', `${wheelSettings.intro.digitsSize}px ${wheelSettings.intro.digitsFont}`);
    const digitWidth = digitMeasure.width

    var finalTextNode = new Konva.Text({
      x: x -finalTextMeasure.width/2 + digitWidth/2,
      //x: x,
      y: y,
      text: text,
      fontSize: wheelSettings.intro.digitsSize,
      fontFamily: wheelSettings.intro.digitsFont,
      fill: wheelSettings.intro.digitsColor,
    });
    layer.add(finalTextNode);
  }
  else {
    var digit = new Konva.Text({
      x: wheelSettings.intro.digitsPosX ? wheelSettings.intro.digitsPosX : posX,
      y: wheelSettings.intro.digitsPosY ? wheelSettings.intro.digitsPosY : posY,
      text: text,
      fontSize: wheelSettings.intro.digitsSize,
      fontFamily: wheelSettings.intro.digitsFont,
      fill: wheelSettings.intro.digitsColor,
      draggable: true,
    });
    if (frameIndex === 0) {
      digit.on('mouseover', (e) => {
        document.body.style.cursor = 'pointer';
      });
      digit.on('mouseout', (e) => {
        document.body.style.cursor = 'default';
      });
      digit.on('dragend', (e) => {
        updateDigitsPos_IntroSettings(e.target.attrs.x, e.target.attrs.y)
      })  
    }
    layer.add(digit);

  }
    
} 

const playWheel = () => {
    //first check if there is an into animation
    if (wheelSettings.intro && wheelSettings.intro.useIntro) {
      playIntroAndSpin()
      return
    }
    spinWheel()
}

const spinWheel = () => {
  const rotationAmount = 360 * 5 + 60;
  //const rotationAmount = 360 * 5 + Math.random() * 360; // 5 full rotations + random spin
  const wheel = canvasRef.current.find('#wheelGroup')[0]
  wheel.to({
      rotation: wheel.rotation() + rotationAmount,
      duration: spinDuration,
      easing: Konva.Easings.EaseOut,
      onFinish: () => {if (wheelSettings.intro && wheelSettings.intro.renderInPreview) initKonva(wheelSettings)},
  });

}

function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

const loadGoogleFont = (fontName) => {
  const link = document.createElement('link');
  link.href = `https://fonts.googleapis.com/css2?family=${fontName.replace(" ", "+")}:wght@400;700&display=swap`;
  link.rel = 'stylesheet';
  document.head.appendChild(link);
};


const getAnimationFrames = async (index) => {
  let frames = [];
  //const bgImg = await loadKonvaBackgroundImageCanvas();
  //const layer = canvasRef.current.getLayers()[0]


  if (wheelSettings.intro && wheelSettings.intro.useIntro) {
    const numIntroFrames = wheelSettings.intro.finalText.length > 0 ? 4 : 3
    for (let i=0; i<numIntroFrames; i+=1) {
      await initKonva(wheelSettings, i);
      frames.push({frame: canvasRef.current.toDataURL(), isIntro: true}); //defaults to png
    }
    await initKonva(wheelSettings, -1);
  }

  const sliceAngle = (360 / wheelSettings.slices.length)
  const startAngle = -sliceAngle * index

  const deltaAngle = 30;
  const wheel = canvasRef.current.find('#wheelGroup')[0]

  for (let i=0; i< 12; i+=1) {
    wheel.rotation(startAngle + deltaAngle * i)
    frames.push({frame: canvasRef.current.toDataURL(), isIntro: false}); //defaults to png
  }
  return frames;
  //if (props.onFramesChange) props.onFramesChange(frames)
}
const handleIconChange = (sliceIndex, iconInfo) => {

  //console.log(iconInfo, isMouseDown)
  updateSliceSettings(sliceIndex, 'icon', iconInfo);
}

if (props.noRender) return <><div className='hidden' id="canvasContainer" ref={canvasRef}></div></>

else  return <>
      <div className="flex flex-row gap-x-4">
            <div className="w-[300px]">
            <InputText
                    displayName="Name"
                    value={snippetName}
                    onChange={(val) => {handleSnippetNameChange(val);}}
                    error={getErrorMessage(props.validationErrorsList, 'snippetName')}
            />
            </div>

            <div className="w-[300px]">
            <InputText
                        displayName="Description"
                        value={snippetDesc}
                        onChange={(val) => {handleSnippetDescChange(val);}}
                        error={getErrorMessage(props.validationErrorsList, 'snippetDesc')}
            />
            </div>
  
    </div>

    <div className='grid grid-cols-2 mt-4 text-ccColorDarkTeal'>
        <div className='max-h-[700px]  overflow-auto'>
          <div className='border rounded p-2' >
            <div className='flex flex-row gap-x-8'>
              <div>
                <CcCheckbox
                  displayName="Add intro"
                  checked={wheelSettings.intro ? wheelSettings.intro.useIntro : false}
                  onChange={(e) => {updateIntroSettings('useIntro', e.target.checked);}}
                />
              </div>
              {wheelSettings.intro && wheelSettings.intro.useIntro &&
                <div>
                <CcCheckbox
                  displayName="Preview"
                  checked={wheelSettings.intro ? wheelSettings.intro.renderInPreview : false}
                  onChange={(e) => {updateIntroSettings('renderInPreview', e.target.checked);}}
                />
              </div>              
              }       
            </div>
            {wheelSettings.intro && wheelSettings.intro.useIntro && <div>
                <div className='flex flex-row gap-x-4'>
                  <div className=''>
                    <div className='block text-sm font-medium leading-6 text-gray-900'>Colour</div>
                    <LionColorPicker color={wheelSettings.intro ? wheelSettings.intro.color : '#000'}
                      onChange={(color) => updateIntroSettings('color', color)}
                      />
                  </div>
                  <div className="w-[200px]">
                    <InputNumber
                          displayName="Opacity"
                          min={0} max={1} incr={.05}
                          value={wheelSettings.intro ? wheelSettings.intro.opacity : 1}
                          onChange={(val) => {updateIntroSettings('opacity', val);}}
                        />
                  </div>

                </div>

                <div className='flex flex-row gap-x-4 mt-2'>
                  <div className=''>
                    <div className='block text-sm font-medium leading-6 text-gray-900'>Digits Colour</div>
                    <LionColorPicker color={wheelSettings.intro ? wheelSettings.intro.digitsColor : '#fff'}
                      onChange={(color) => updateIntroSettings('digitsColor', color)}
                      />
                  </div>
                  <div className="w-[200px]">
                    <InputNumber
                          displayName="Digits size"
                          min={12} max={400} incr={1}
                          value={wheelSettings.intro ? wheelSettings.intro.digitsSize : 64}
                          onChange={(val) => {updateIntroSettings('digitsSize', val);}}
                        />
                  </div>
                  <GoogleFontsSelector
                        displayName="Digits font"
                        fonts={fonts}
                        selected={wheelSettings.intro ? wheelSettings.intro.digitsFont : 'Calibri'}
                        onChange={(val) => {updateIntroSettings('digitsFont', val); loadGoogleFont(val);}}
                  />

                </div>

                <div className='flex flex-row gap-x-4 mt-2'>
                  <div className="w-[200px]">
                    <InputNumber
                          displayName="Digits X"
                          min={0} max={4000} incr={1}
                          value={wheelSettings.intro && wheelSettings.intro.digitsPosX ? wheelSettings.intro.digitsPosX : getIntroDigitsCenter()[0]}
                          onChange={(val) => {updateIntroSettings('digitsPosX', val);}}
                        />
                  </div>
                  <div className="w-[200px]">
                    <InputNumber
                          displayName="Digits Y"
                          min={12} max={400} incr={1}
                          value={wheelSettings.intro && wheelSettings.intro.digitsPosY ? wheelSettings.intro.digitsPosY : getIntroDigitsCenter()[1]}
                          onChange={(val) => {updateIntroSettings('digitsPosY', val);}}
                        />
                  </div>

                </div>

                <div className='flex flex-row gap-x-4 mt-2'>
                  <div className="w-[300px]">
                    <InputText
                          displayName="3..2..1.."
                          value={wheelSettings.intro && wheelSettings.intro.finalText ? wheelSettings.intro.finalText : ''}
                          onChange={(val) => {updateIntroSettings('finalText', val);}}
                        />
                  </div>

                </div>
              </div>
            }

          </div>
          <div className='border rounded p-2 mt-2'>
            <div className='text-sm font-medium leading-6 text-gray-900 font-poppins'>Background Settings</div>
            <div className='flex flex-row items-start gap-x-6 -ml-2'>
              <div className='flex flex-row items-center cursor-pointer' onClick={() => updateWheelSettings('backgroundMakeTransparent', true)} >
            <Radio
                  checked={wheelSettings.backgroundMakeTransparent}
                  onChange={() => updateWheelSettings('backgroundMakeTransparent', true)}
                  value="transparent"
                  name="radio-coverType"
                  inputProps={{ 'aria-label': 'A' }}
                  sx={{
                    '&.Mui-checked': {
                      color: ccColorTeal,
                    },
                  }}
                />
                <div>Transparent</div>
              </div>
              <div className='flex flex-row gap-x-4'>
                <div className='flex flex-row items-center cursor-pointer' onClick={() => updateWheelSettings('backgroundMakeTransparent', false)}>
                  <Radio
                      checked={!wheelSettings.backgroundMakeTransparent}
                      onChange={() => updateWheelSettings('backgroundMakeTransparent', false)}
                      value="solidColor"
                      name="radio-coverType"
                      inputProps={{ 'aria-label': 'A' }}
                      sx={{
                        '&.Mui-checked': {
                          color: ccColorTeal,
                        },
                      }}
                    />
                  <div>Colour</div>
                </div>
                <LionColorPicker color={wheelSettings.backgroundColor}
                  onChange={(color) => updateWheelSettings('backgroundColor', color)}
                />
      
      
              </div>        
            </div>
            <div className='mt-2'>
              {(wheelSettings.backgroundImageDataUrl === undefined || wheelSettings.backgroundImageDataUrl.length === 0) &&
                  <FileSelector noDeleteButton
                  text="Upload image"
                  onChange={(dataURL) => updateWheelSettings('backgroundImageDataUrl', dataURL)}
                  base64={props.action ? props.action.imgB64 : undefined}
                />
              }
              {wheelSettings.backgroundImageDataUrl && wheelSettings.backgroundImageDataUrl.length > 0 && <div className='flex flex-row gap-x-2 items-center'>
                <CcActionButtonOutlined
                  onClick={() => updateWheelSettings('backgroundImageDataUrl', '')}
                >Remove image</CcActionButtonOutlined>

                <div className=''>
                  <Tooltip title="Set the canvas size to be the same as the image size" placement='right' >
                    <IconButton sx={{color: '#fff',  backgroundColor: ccColorDarkTeal, ":hover": {backgroundColor: '#8ED2D7'}}} 
                        onClick={() => updateCanvasSize(bgImageSize.width, bgImageSize.height)}
                      ><Iconify icon="mynaui:center-focus" width="20" height="20" />
                    </IconButton>
                  </Tooltip>              
                </div>
              </div>
              }
            </div>
            <div className='flex flex-row mt-2 items-center gap-x-6'>
              <div className="w-[200px]">
                <InputNumber
                      displayName="Width"
                      min={0} max={2000} incr={5}
                      value={wheelSettings.canvasWidth}
                      onChange={(val) => {updateWheelSettings('canvasWidth', val);}}
                    />
              </div>
              <div className="w-[200px]">
                <InputNumber
                      displayName="Height"
                      min={0} max={2000} incr={5}
                      value={wheelSettings.canvasHeight}
                      onChange={(val) => {updateWheelSettings('canvasHeight', val);}}
                    />
              </div>
            </div>

          </div>

          <div className='border rounded p-2 mt-2'>
            <div className='text-sm font-medium leading-6 text-gray-900 font-poppins'>Wheel Design Settings</div>

            <div className='flex flex-row gap-x-4 mt-2'>
              <div className="w-[180px]">
                <InputNumber
                      displayName="Radius"
                      min={0} max={2000} incr={25}
                      value={wheelSettings.radius}
                      onChange={(val) => {updateWheelSettings('radius', val);}}
                    />
              </div>
              <div className="w-[180px]">
                <InputNumber
                      displayName="Center X"
                      min={0} max={2000} incr={1}
                      value={wheelSettings.centerX}
                      onChange={(val) => {updateWheelSettings('centerX', val);}}
                    />
              </div>
              <div className="w-[180px]">
                <InputNumber
                      displayName="Center Y"
                      min={0} max={2000} incr={1}
                      value={wheelSettings.centerY}
                      onChange={(val) => {updateWheelSettings('centerY', val);}}
                    />
              </div>
              <div className='mt-[26px]'>
                <Tooltip title="Move to center" placement='right' >
                  <IconButton sx={{color: '#fff',  backgroundColor: ccColorDarkTeal, ":hover": {backgroundColor: '#8ED2D7'}}} 
                      onClick={() => updateWheelCenter(wheelSettings.canvasWidth/2, wheelSettings.canvasHeight/2)}
                    ><Iconify icon="mynaui:center-focus" width="20" height="20" />
                  </IconButton>
                </Tooltip>              
              </div>

            </div>

            <div className='flex flex-row mt-2 items-center gap-x-6'>
              <div className="w-[200px]">
                <InputNumber
                      displayName="Slices border width"
                      min={0} max={20} incr={1}
                      value={wheelSettings.sliceStrokeWidth}
                      onChange={(val) => {updateWheelSettings('sliceStrokeWidth', val);}}
                    />
              </div>
              <div className=''>
                <div className='block text-sm font-medium leading-6 text-gray-900'>Slices border colour</div>
                <LionColorPicker color={wheelSettings.sliceStrokeColor}
                  onChange={(color) => updateWheelSettings('sliceStrokeColor', color)}
                  />
              </div>
            </div>
            <div className='flex flex-row mt-2 items-center gap-x-6'>
              <div className="w-[200px]">
                <InputNumber
                      displayName="Outer border width"
                      min={0} max={20} incr={1}
                      value={wheelSettings.outerBorderStrokeWidth}
                      onChange={(val) => {updateWheelSettings('outerBorderStrokeWidth', val);}}
                    />
              </div>
              <div className=''>
                <div className='block text-sm font-medium leading-6 text-gray-900'>Outer border colour</div>
                <LionColorPicker color={wheelSettings.outerBorderColor}
                  onChange={(color) => updateWheelSettings('outerBorderColor', color)}
                  />
              </div>
            </div>
          </div>

          <div className='border rounded p-2 mt-2'>
            <div className='text-sm font-medium leading-6 text-gray-900 font-poppins'>Center Circle Design</div>
            <div className='flex flex-row gap-x-4 mt-2'>
            <div className="w-[180px]">
              <InputNumber
                    displayName="Radius"
                    min={0} max={1000} incr={2}
                    value={wheelSettings.kernel ? wheelSettings.kernel.radius : 0}
                    onChange={(val) => {updateKernelSettings('radius', val);}}
                  />
            </div>
            <div className=''>
                <div className='block text-sm font-medium leading-6 text-gray-900'>Colour</div>
                <LionColorPicker color={wheelSettings.kernel ? wheelSettings.kernel.color : '#00'}
                  onChange={(color) => updateKernelSettings('color', color)}
                  />
              </div>

            </div>
            <div className='flex flex-row mt-2 items-center gap-x-6'>
            <div className="w-[200px]">
              <InputNumber
                    displayName="Border width"
                    min={0} max={20} incr={1}
                    value={wheelSettings.kernel ? wheelSettings.kernel.strokeWidth : 0}
                    onChange={(val) => {updateKernelSettings('strokeWidth', val);}}
                  />
            </div>
            <div className=''>
              <div className='block text-sm font-medium leading-6 text-gray-900'>Border colour</div>
              <LionColorPicker color={wheelSettings.kernel ? wheelSettings.kernel.strokeColor : '#fff'}
                onChange={(color) => updateKernelSettings('strokeColor', color)}
                />
            </div>
          </div>

          </div>


          <div className='border rounded p-2 mt-2'>
            <div>Pointer Settings</div>

            <div className='flex flex-row items-center gap-x-6 -ml-2'>
              <div className='flex flex-row items-center cursor-pointer' onClick={() => updatePointerSettings('shape', 'house')} >
            <Radio
                  checked={wheelSettings.pointer ? wheelSettings.pointer.shape === 'house' : false}
                  onChange={() => updatePointerSettings('shape', 'house')}
                  value="house"
                  name="radio-coverType"
                  inputProps={{ 'aria-label': 'A' }}
                  sx={{
                    '&.Mui-checked': {
                      color: ccColorTeal,
                    },
                  }}
                />
                <div><Iconify icon="ph:house-simple-duotone" rotate="90" width={32} /></div>
              </div>
              <div className='flex flex-row gap-x-4'>
                <div className='flex flex-row items-center cursor-pointer' onClick={() => updatePointerSettings('shape', 'triangle')}>
                  <Radio
                      checked={wheelSettings.pointer ? wheelSettings.pointer.shape === 'triangle' : true}
                      onChange={() => updatePointerSettings('shape', 'triangle')}
                      value="triangle"
                      name="radio-coverType"
                      inputProps={{ 'aria-label': 'A' }}
                      sx={{
                        '&.Mui-checked': {
                          color: ccColorTeal,
                        },
                      }}
                    />
                  <div><Iconify icon="icon-park-twotone:triangle" rotate="90" width={32} /></div>
                </div>
      
      
              </div>

              <div className='flex flex-row items-center gap-x-1'>
                <div onClick={() => updatePointerScaleFactor(.1)} className='w-[34px] h-[34px] flex items-center justify-center rounded-full bg-ccColorDarkTeal text-white hover:bg-ccColorTeal hover:cursor-pointer'><Iconify icon="icomoon-free:enlarge" width="22" height="22" /></div>
                <div onClick={() => updatePointerScaleFactor(-.1)} className='w-[34px] h-[34px] flex items-center justify-center rounded-full bg-ccColorDarkTeal text-white hover:bg-ccColorTeal hover:cursor-pointer'><Iconify icon="lets-icons:reduce" width="22" height="22" /></div>
              </div>
            
            </div>


            <div className='flex flex-row gap-x-6 mt-1'>
              <div className=''>
                <div className='block text-sm font-medium leading-6 text-gray-900'>Colour</div>
                <LionColorPicker color={wheelSettings.pointer ? wheelSettings.pointer.color : '#000'}
                  onChange={(color) => updatePointerSettings('color', color)}
                  />
              </div>
              <div className=''>
                <div className='block text-sm font-medium leading-6 text-gray-900'>Stroke Colour</div>
                <LionColorPicker color={wheelSettings.pointer ? wheelSettings.pointer.strokeColor: '#000'}
                  onChange={(color) => updatePointerSettings('strokeColor', color)}
                  />
              </div>
              <div className="w-[200px]">
                <InputNumber
                    displayName="Border width"
                    min={0} max={20} incr={1}
                    value={wheelSettings.pointer ? wheelSettings.pointer.strokeWidth : 0}
                    onChange={(val) => {updatePointerSettings('strokeWidth', val);}}
                  />
              </div>
            </div>

            
          </div>


          <div className='mt-4'>
            <div className='flex flex-row gap-x-2 items-center'>
              <div className='font-semibold text-lg'>Slices</div>
              <IconButton sx={{color: '#fff',  backgroundColor: ccColorDarkTeal, ":hover": {backgroundColor: '#8ED2D7'}}} 
                  onClick={handleAddSlice}
                ><Iconify icon="ic:baseline-plus" width="20" height="20" />
              </IconButton>
              <IconButton sx={{color: '#fff', backgroundColor: ccColorDarkTeal, ":hover": {backgroundColor: '#8ED2D7'}}} 
                  onClick={handleRemoveSlice}
                ><Iconify icon="ic:baseline-minus" width="20" height="20" />
              </IconButton>

            </div>
            {wheelSettings && wheelSettings.slices && <>
              {wheelSettings.slices.map((s, index) => <div className='border rounded mt-2 p-2'>
                <div className='text-lg font-semibold'>Slice {index +1} Design & Content</div>

                <div className='flex flex-row gap-x-6'>
                  <div className=''>
                    <div className='block text-sm font-medium leading-6 text-gray-900'>Slice Colour</div>
                    <LionColorPicker color={s.color}
                      onChange={(color) => updateSliceSettings(index, 'color', color)}
                      />
                  </div>
                  <div className="w-[300px]">
                    <InputText
                            displayName="Title Content"
                            value={s.text}
                            onChange={(val) => {updateSliceSettings(index, 'text', val);}}
                    />
                  </div>
                  <div className=''>
                    <div className='block text-sm font-medium leading-6 text-gray-900'>Text Colour</div>
                    <LionColorPicker color={s.textColor}
                      onChange={(color) => updateSliceSettings(index, 'textColor', color)}
                      />
                  </div>
                </div>

                <div className='mt-2 flex flex-row gap-x-2 items-center'>
                  <div className="w-[200px]">
                    <InputNumber
                          displayName="Text size"
                          min={8} max={100} incr={1}
                          value={s.fSize}
                          onChange={(val) => {updateSliceSettings(index, 'fSize', val);}}
                        />
                  </div>
                   <div className="w-[160px] ml-2">
                    <InputNumber
                          displayName="Title line height"
                          min={0.5} max={3} incr={.1}
                          value={s.titleLineHeight}
                          onChange={(val) => {updateSliceSettings(index, 'titleLineHeight', val);}}
                    />
                  </div>
             
                </div>

                <div className='mt-2 flex flex-row gap-x-2 items-center'>
                  <GoogleFontsSelector
                        displayName="Title font"
                        fonts={fonts}
                        selected={s.fName}
                        onChange={(val) => {updateSliceSettings(index, 'fName', val); loadGoogleFont(val);}}
                  />
                   <div className="w-[160px] ml-2">
                    <InputNumber
                          displayName="Weight"
                          min={100} max={900} incr={100}
                          value={s.titleFontWeight ? s.titleFontWeight : 400}
                          onChange={(val) => {updateSliceSettings(index, 'titleFontWeight', val);}}
                    />
                  </div>
             
                </div>

                <div className='flex flex-row gap-x-6 mt-2'>
                  <div className="w-[300px]">
                    <InputText
                            displayName="Subtitle"
                            value={s.subtitle}
                            onChange={(val) => {updateSliceSettings(index, 'subtitle', val);}}
                    />
                  </div>
                  <div className=''>
                    <div className='block text-sm font-medium leading-6 text-gray-900'>Subtitle Colour</div>
                    <LionColorPicker color={s.subtitleColor}
                      onChange={(color) => updateSliceSettings(index, 'subtitleColor', color)}
                      />
                  </div>
                </div>

                <div className='mt-2 flex flex-row gap-x-2 items-center'>
                  <div className="w-[200px]">
                    <InputNumber
                          displayName="Subtitle text size"
                          min={8} max={100} incr={1}
                          value={s.subtitleFSize}
                          onChange={(val) => {updateSliceSettings(index, 'subtitleFSize', val);}}
                        />
                  </div>
                   <div className="w-[160px] ml-2">
                    <InputNumber
                          displayName="Subtitle line height"
                          min={0.5} max={3} incr={.1}
                          value={s.subTitleLineHeight}
                          onChange={(val) => {updateSliceSettings(index, 'subTitleLineHeight', val);}}
                    />
                  </div>

                </div>

                <div className='mt-2 flex flex-row gap-x-2 items-center'>
                  <GoogleFontsSelector
                        zIndex={100}
                        displayName="Subtitle font"
                        fonts={fonts}
                        selected={s.subtitleFName}
                        onChange={(val) => {updateSliceSettings(index, 'subtitleFName', val); loadGoogleFont(val);}}
                  />
                   <div className="w-[160px] ml-2">
                    <InputNumber
                          displayName="Weight"
                          min={100} max={900} incr={100}
                          value={s.subtitleFontWeight ? s.subtitleFontWeight : 400}
                          onChange={(val) => {updateSliceSettings(index, 'subtitleFontWeight', val);}}
                    />
                  </div>

                </div>


                <div className='mt-2 flex flex-row gap-x-2 items-center'>
                  <div className="w-[220px]">
                    <InputNumber
                          displayName="Height between title and sub-title"
                          min={4} max={100} incr={1}
                          value={s.heightBetweenTitleAndSubtitle}
                          onChange={(val) => {updateSliceSettings(index, 'heightBetweenTitleAndSubtitle', val);}}
                        />
                  </div>
             
                </div>

                <div className='mt-1 -ml-2'>
                  <CcCheckbox
                    displayName="Add icon"
                    checked={s.addIcon}
                    onChange={(e) => {updateSliceSettings(index, 'addIcon', e.target.checked);}}
                  />                
                </div>
                {s.addIcon && <div>
                      <SvgSelector ref={svgSelectorRef} idPrefix={`slice${index}`}
                          onChange={(val, isMouseDown) => handleIconChange(index, val, isMouseDown)}
                          pointerXml={s.icon.xml} 
                      />
                </div>
                }


                </div>)
              }
            </>}
          </div>
        </div>


        <div className='flex flex-col items-center overflow-auto'>
            <div className='font-semibold'>Preview</div>
            
                <div id="canvasContainer" ref={canvasRef}></div>              
            
            <CcActionButton onClick={playWheel}><Iconify icon="heroicons:play" width={24}/></CcActionButton>
        </div>

    </div>

    </>
})

const SpinningWheelOffersManager = (props) => {
  const canvasRefs = useRef([]);
  if (canvasRefs.current.length !== 100) {
    canvasRefs.current = Array.from({ length: 100 }, (_, i) => canvasRefs.current[i] || { current: null });
  }


  useEffect(() => {
    if (props.wheelSettings) {
      const numSlices = props.wheelSettings.slices.length
      
      //console.log(canvasRefs.current)
      for (let i=0; i<numSlices; i+=1) renderSlice(i)
      
    }
  }, [props.wheelSettings])



  const degToRad = (deg) => {
    return deg * Math.PI / 180;
  }
  
  const renderSlice = (sliceIndex) => {
    
    const wheelSettings = props.wheelSettings;

    const sliceAngle = (360 / wheelSettings.slices.length)
    const sliceAngleRad = degToRad(sliceAngle)
    const wedgeWidth = Math.sqrt(2 * wheelSettings.radius * wheelSettings.radius -2*wheelSettings.radius*wheelSettings.radius*Math.cos(sliceAngleRad))
    //console.log(wedgeWidth)
    const wheel = new Konva.Group({ id: "wheelGroup", x: wedgeWidth / 2 +5, y: wheelSettings.radius +5});

    const stage = new Konva.Stage({
        container: `slice${sliceIndex}`,
    });

    const canvasRef = canvasRefs.current[sliceIndex].current 

    canvasRef.current = stage;


    canvasRef.current.width(wedgeWidth + 10);
    canvasRef.current.height(wheelSettings.radius +10);
    canvasRef.current.container().style.width = `${wedgeWidth + 10}px`;
    canvasRef.current.container().style.height = `${wheelSettings.radius + 10}px`;

    

    const layer = new Konva.Layer();

    layer.add(wheel);
    stage.add(layer);

    const wedge = new Konva.Wedge({
      x: 0,
      y: 0,
      radius: wheelSettings.radius,
      angle: sliceAngle,
      fill: wheelSettings.slices[sliceIndex].color,
      rotation: -90 - sliceAngle / 2,
      stroke: wheelSettings.sliceStrokeColor,
      strokeWidth: wheelSettings.sliceStrokeWidth,
  });
  wheel.add(wedge);


  let finalHeight = renderText(wheelSettings.textStartHeight, sliceIndex, wheelSettings.slices[sliceIndex])
  finalHeight -= wheelSettings.slices[sliceIndex].heightBetweenTitleAndSubtitle;
  let iconStartHeight = finalHeight
  finalHeight = renderText(finalHeight, sliceIndex, wheelSettings.slices[sliceIndex], true)
  if (wheelSettings.slices[sliceIndex].subtitle.length > 0) iconStartHeight = finalHeight;


  if (wheelSettings.slices[sliceIndex].addIcon) {
    const imageObj = new Image();
    imageObj.src = wheelSettings.slices[sliceIndex].icon.b64;

    imageObj.onload = function () {
      const konvaImage = new Konva.Image({
        x: -imageObj.width/2,
        y: -iconStartHeight,
        image: imageObj,
        width: imageObj.width,
        height: imageObj.height,
      });

      wheel.add(konvaImage);

      layer.draw();
    };
  }


  }

  const renderText = (startHeight, sliceIndex, slice, renderSubtitle) => {
    const wheelSettings = props.wheelSettings;

    let words = slice.text.split(' ');
    if (renderSubtitle) words = slice.subtitle.split(' ')
    words.push("") //workaround - we add an empty word so it works better

    let lines = [];
    let numLinesUsed = 0;
    let currentLine = '';
    const safetyWidthConstraint = 20;
  
    const sliceAngle = (360 / wheelSettings.slices.length)
  
    //console.log(startHeight)
    let widthAtCurrentHeight = startHeight / Math.cos(degToRad(sliceAngle/2))
    
    //console.log(widthAtCurrentHeight)
    currentLine = words[0]
    let currentLineMinusOneWord = ''
    let previousTextWidth = 0;
    for (let i = 1; i < words.length; i++) {
      let textWidth = 0;
      if (renderSubtitle) textWidth = getTextWidth(currentLine, `${slice.subtitleFSize}px ${slice.subtitleFName}`);
      else textWidth = getTextWidth(currentLine, `${slice.fSize}px ${slice.fName}`);
        //console.log(currentLine)
      //console.log(textWidth)
      if (textWidth >= widthAtCurrentHeight - safetyWidthConstraint) {
        lines.push({txt: currentLineMinusOneWord, txtLength: previousTextWidth, availableWidth: widthAtCurrentHeight})
        currentLine = words[i-1]
        currentLineMinusOneWord = ''
        previousTextWidth = 0
        numLinesUsed += 1
        if (numLinesUsed >= 3) break;
        widthAtCurrentHeight = (startHeight - slice.fSize) / Math.cos(degToRad(sliceAngle/2))
        if (renderSubtitle) widthAtCurrentHeight = (startHeight - slice.subtitleFSize) / Math.cos(degToRad(sliceAngle/2))
          //console.log(widthAtCurrentHeight)
      }
      currentLineMinusOneWord = currentLine
      previousTextWidth = textWidth;
      currentLine += ' ' + words[i];
    }
    if (currentLine.length > 0) {
      if (renderSubtitle) lines.push({txt: currentLine, availableWidth: widthAtCurrentHeight, txtLength: getTextWidth(currentLine, `${slice.subtitleFSize}px ${slice.subtitleFName}`)})
      else lines.push({txt: currentLine, availableWidth: widthAtCurrentHeight, txtLength: getTextWidth(currentLine, `${slice.fSize}px ${slice.fName}`)})
    }
      const canvasRef = canvasRefs.current[sliceIndex].current 
      const wheel = canvasRef.current.find('#wheelGroup')[0]
      //const layer = canvasRef.getLayers()[0]
  
      //console.log(lines)
    //for each line we draw a konva text
    for (const l of lines) {l.txt = l.txt.trim()}
  
    let finalHeight = 0;
    for (let i=0; i<lines.length; i+=1) {
      const fSize = renderSubtitle ? slice.subtitleFSize : slice.fSize
      const fName = renderSubtitle ? slice.subtitleFName : slice.fName
  
      const txtLength = getTextWidth(lines[i].txt, `${fSize}px ${fName}`)

      const text = new Konva.Text({
        //x: -(lines[i].availableWidth)/2 +(lines[i].availableWidth - txtLength) / 2 - 6,
        x: -(txtLength) / 2,
        y: renderSubtitle ? -startHeight + slice.subtitleFSize * i : -startHeight + slice.fSize * i,
        text: lines[i].txt,
        fontSize: fSize,
        fontFamily: fName,
        fill: renderSubtitle ? slice.subtitleColor : slice.textColor,
        rotation: 0,
      });
      finalHeight = text.attrs.y

      wheel.add(text)

      //wheel.add(text)
      //rotateTextInGroupAroundPoint(text, sliceAngle * sliceIndex, wheelSettings.canvasWidth / 2, wheelSettings.canvasHeight / 2)
      //console.log(text.attrs)
    }
    return (finalHeight + slice.fSize) * -1 //we need to change the sign 

  
  /*
    var redLine = new Konva.Line({
      points: [-widthAtCurrentHeight/2, -startHeight, widthAtCurrentHeight/2, -startHeight],
      stroke: 'red',
      strokeWidth: 4,
      lineCap: 'round',
      lineJoin: 'round',
    });
  */
  
  
  
  
  }

  const updateSliceSettings = (sliceIndex, propName, propValue) => {
    const wheelSettings = props.wheelSettings;

    const newSlicesArr = [...wheelSettings.slices]
    const newSlice = newSlicesArr[sliceIndex]
    newSlice[propName] = propValue
    newSlicesArr.splice(sliceIndex, 1, newSlice);
  
  
    const newSettings = {...wheelSettings, slices: newSlicesArr}
    if (props.onChange) props.onChange(newSettings)
  }
  const updateDefaultSlice = (sliceIndex) => {
    //console.log(props.wheelSettings)
    if (props.wheelSettings === undefined) return
    const wheelSettings = props.wheelSettings;

    const newSlicesArr = [...wheelSettings.slices]
    for (let i=0; i<newSlicesArr.length; i+=1) newSlicesArr[i].isDefault = false;

    newSlicesArr[sliceIndex].isDefault = true;
   
    const newSettings = {...wheelSettings, slices: newSlicesArr}
    if (props.onChange) props.onChange(newSettings)
  }

  
  return <div>
    
    {props.wheelSettings.slices.map((slice, index) => <div className='flex flex-row gap-x-4 items-center'>
      <div id={`slice${index}`} ref={canvasRefs.current[index] }></div>
      <div>
        <div className="w-96 font-roboto">
            <div className='flex flex-row items-center gap-x-1'>
                <label htmlFor="Endpoint" className="block text-sm font-medium text-ccColorDarkTeal font-poppins">
                  Button HREF
                </label>
                <InfoToolTip 
                    placement='right'
                    headLine='Button HREF'
                    message="Insert the URL that you wish to direct participants to. This link should include any discount population parameters and tracking that you wish to carry forward."
                />
            </div>
            <InputURL
              //displayName="Name"
              value={slice.href}
              onChange={(val) => {updateSliceSettings(index, 'href', val);}}
              error={getErrorMessageForArray(props.validationErrorsList, 'wheelSettingsSlicesHref', index)}
              />
        </div>
        <div className='mt-2'>
          <div className='flex flex-row items-center gap-x-1'>
              <label htmlFor="Endpoint" className="block text-sm font-medium text-ccColorDarkTeal font-poppins">
                URL parameter mapping
              </label>
              <InfoToolTip 
                  placement='right'
                  headLine='URL parameter mapping'
                  message="It allows to set where the spinning wheel will stop. You can provide a custom mapping value which you will have to merge in the “ccrev” parameter of our tag.
You can also leave this field empty and still use the slice number to choose where the wheel will stop."
              />
          </div>
          <InputText
            //displayName="URL parameter mapping"
            value={slice.mapping}
            onChange={(val) => {updateSliceSettings(index, 'mapping', val);}}
            error={getErrorMessageForArray(props.validationErrorsList, 'wheelSettingsSlicesMapping', index)}
            />
        </div>
      </div>
      <div>
          <div className='flex flex-row items-center cursor-pointer'>
            <CcCheckbox 
            checked={slice.notUsed}
            onChange={(e) => {updateSliceSettings(index, 'notUsed', e.target.checked);}}
            />
          <div className='text-ccColorDarkTeal' onClick={(e) => {updateSliceSettings(index, 'notUsed', !slice.notUsed);}}>Do not use</div>
          {getErrorMessage(props.validationErrorsList, 'wheelSettingsSlicesDoNotUse') &&
          <div className='ml-2 text-sm text-red-500'>{getErrorMessage(props.validationErrorsList, 'wheelSettingsSlicesDoNotUse')}</div>
          }
          </div>
        
          <div className='flex flex-row items-center cursor-pointer text-ccColorDarkTeal' onClick={() => updateDefaultSlice(index)} >
            <Radio
              checked={slice.isDefault}
              onChange={() => updateDefaultSlice(index)}
              value="useEmailCover"
              name="radio-coverType"
              inputProps={{ 'aria-label': 'A' }}
              sx={{
                '&.Mui-checked': {
                  color: ccColorTeal,
                },
              }}
            />
            <div>Set as default</div>
          </div>

      </div>
    </div>)}
    
  </div>
}

const SpinningWheelExpiryManager = (props) => {
  const [expirySettings, setExpirySettings] = useState(defaultWheelSettings.expiry)
  const [timeZones, setTimeZones] = useState(undefined);

  useEffect(() => {
    if (props.wheelSettings.expiry) setExpirySettings(props.wheelSettings.expiry)
  }, [props.wheelSettings])

  useEffect(() => {
    getTimezones()
  }, [])
  
  const getTimezones = async () => {
    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/Settings/timezones`;
      const response = await axios.get(url);
      const data = response.data;

      const result = data.map(d => {return {id: d.zoneId, name: d.zoneName}});
      setTimeZones(result);

    } catch (error) {
      //console.log(error);
    }
  }
  

  const updateSettings = (propName, propValue) => {
    const newSettings = {...expirySettings, [propName]: propValue}

    if (props.onChange) props.onChange(newSettings)
  }



  return <div className='text-ccColorDarkTeal'>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
    <div className='text-lg font-semibold'>Would you like to show a different image when this offer expires?</div>
    <div className='flex flex-row items-start gap-x-6 -ml-2'>
              <div className='flex flex-row items-center cursor-pointer' onClick={() => updateSettings('expirySettingsActive', true)}>
            <Radio
                  checked={expirySettings.expirySettingsActive}
                  onChange={() => updateSettings('expirySettingsActive', true)}
                  value="transparent"
                  name="radio-coverType"
                  inputProps={{ 'aria-label': 'A' }}
                  sx={{
                    '&.Mui-checked': {
                      color: ccColorTeal,
                    },
                  }}
                />
                <div>Yes</div>
              </div>
              <div className='flex flex-row gap-x-4'>
                <div className='flex flex-row items-center cursor-pointer' onClick={() => updateSettings('expirySettingsActive', false)}>
                  <Radio
                      checked={!expirySettings.expirySettingsActive}
                      onChange={() => updateSettings('expirySettingsActive', false)}
                      value="solidColor"
                      name="radio-coverType"
                      inputProps={{ 'aria-label': 'A' }}
                      sx={{
                        '&.Mui-checked': {
                          color: ccColorTeal,
                        },
                      }}
                    />
                  <div>No</div>
                </div>      
      
              </div>        
    </div>
    {expirySettings.expirySettingsActive && <div className='mt-4'>
              <div className='flex flex-row items-center gap-x-6'>      
                  <div className='flex flex-row items-center gap-x-4'>
                <div>
                <label htmlFor="timerDate" className="block text-sm font-medium leading-6 text-gray-900">
                  Date
                </label>
                <div className="mt-1">
                <DateTimePicker
                      value={dayjs(expirySettings.expiryDate)}
                      ampm={false}
                      viewRenderers={{
                        hours: renderTimeViewClock,
                        minutes: renderTimeViewClock,
                        seconds: renderTimeViewClock,
                      }}
                      onChange={(newDate) => updateSettings('expiryDate', newDate.toJSON())}
                    />
                </div>
                </div>        
                <div>
                  <label htmlFor="snippetDescription" className="block text-sm font-medium leading-6 text-gray-900">
                    Time zone
                  </label>
                  <div className="mt-1">
                    <LionCombo items={timeZones}
                      onChange={(timezone) => updateSettings('expiryTimezoneId', timezone.id)}
                      selectedItemId={expirySettings.expiryTimezoneId}
                      zIndex={100}
                    />
                  </div>
                </div>
      
                  </div>
      
              </div>
      

      <div className='mt-4 border rounded p-2 h-[330px] flex flex-row items-center gap-x-32'>
        <FileSelector noDeleteButton
          text="Upload image"
          onChange={(dataUrl) => updateSettings('imageB64', dataUrl)}
          //base64={props.action ? props.action.imgB64 : undefined}
        />
        {expirySettings.imageB64 === '' && <div className='bg-slate-200 rounded p-4 mt-2 w-[400px] h-[300px] flex flex-col justify-center items-center'>
              <Iconify icon="carbon:no-image" width={200} />
              <div className='font-poppins font-semibold'>No image uploaded</div>
          </div>

        }
        {expirySettings.imageB64 !== '' && <div className='flex flex-row gap-x-1'>
          <div className='bg-slate-200 rounded p-4 mt-2 w-[400px] h-[300px] flex justify-center'>
            <div className='relative h-full' >

                <img style={{height: 'auto', width: 'auto', maxWidth: '100%', maxHeight: '100%'}} src={`${expirySettings.imageB64}`} />

            </div>
          </div>
              <IconButton sx={{width: '48px', height: '48px'}}
                onClick={() => updateSettings('imageB64', '')}
              ><Iconify icon={lionIcons.Icon_Actions_Cancel} /></IconButton>
          </div>
        }

      </div>
      <div className="w-96 font-roboto mt-4">
            <div className='flex flex-row items-center gap-x-1'>
                <label htmlFor="Endpoint" className="block text-sm font-medium text-ccColorDarkTeal font-poppins">
                  Expiry HREF
                </label>
                <InfoToolTip 
                    placement='right'
                    headLine='Expiry HREF'
                    message="You can optionally redirect your users somewhere else after expiry to the url you provide here."
                />
            </div>
            <InputURL
              value={expirySettings.expiryHref}
              onChange={(val) => {updateSettings('expiryHref', val);}}
              //error={getErrorMessageForArray(props.validationErrorsList, 'wheelSettingsSlicesHref', index)}
              />
        </div>


    </div>
    }
    </LocalizationProvider>
  </div>
}


export default function SpinningWheelWorkflow(props) {
    const [currentStep, setCurrentStep] = useState(0);
    const navigate = useNavigate();
    const [templateId, setTemplateId] = useState(null);
    const [templateHasTimeLabels, setTemplateHasTimeLabels] = useState(false); // we check if the selected template contains time labels (by checking its templateJson)
    //const [snippetData, setSnippetData] = useState({snippetName: '', snippetDesc: '', href: '', wheelSettings: defaultWheelSettings});
    const [snippetData, setSnippetData] = useState(undefined); //it needs to start as undefined to resolve a bug in edit in chrome (popagation of onChange events that were overwriting the element metadata)


    const [successHtmlMsg, setSuccessHtmlMsg] = useState('');
    const [showErrorMsg, setShowErrorMsg] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [showSuccessMsg, setShowSuccessMsg] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const [activeErrorList, setActiveErrorList] = useState([]);
    const [progress, setProgress] = useState(0) //from 0 to 100

    const spinningWheelElementManagerRef = useRef();

    useEffect(() => {
      if (props.snippetId) {
        getSnippetInfo(props.snippetId)
      }
      else {
        setSnippetData({snippetName: '', snippetDesc: '', href: '', wheelSettings: defaultWheelSettings})
      }
    }, [props.snippetId])

  const getSnippetInfo = async (snippetId) => {
      try {  
        const url = `${process.env.REACT_APP_LION_API_URL}/Snippets/${snippetId}`;
        const response = await axios.get(url);
        const data = response.data;
  
        const dataObj = {...data, wheelSettings: JSON.parse(data.snippetSettings).wheelSettings}
        //console.log(dataObj)
        setSnippetData(dataObj);
  
      } catch (error) {
        console.log(error);
      }
    }

    const templateContainsTimeLabels = (templateJson) => {
      let result = false;
      const blocks = templateJson.model.children[0].children;

      blocks.forEach(block => {
        if (block.className === "Text" && block.attrs.id.startsWith('timerLabel')) result = true;
      })
      console.log(result)
      return result;
    }

    const submitDataSnippet = async () => {
      try {
        //console.log(snippetData)
        //snippetDataValidationSchemaOSTracker.validateSync(snippetData, {abortEarly: false});
        setActiveErrorList([])
      }
      catch (e) {
        //console.log(JSON.parse(JSON.stringify(e)))
        const errorList = getErrorListFromYupError(e)
        setActiveErrorList(errorList)
        return false;
      }


      setShowLoader(true);
      setSuccessHtmlMsg('');
    
      try {
          let url = `${process.env.REACT_APP_LION_API_URL}/Snippets/create/16`;
          if (props.snippetId !== null && props.snippetId !== undefined) url = `${process.env.REACT_APP_LION_API_URL}/Snippets/update/16/${props.snippetId}`;
          const snippetSettings = {wheelSettings: snippetData.wheelSettings}
          //console.log(snippetSettings)
          const dataToPost = {...snippetData, href: '', snippetSettings: JSON.stringify(snippetSettings)}

          const response = await axios.post(url, dataToPost);
    
          const snippetId = GetSnippetIdfromSnippetHtml(response.data)

          await uploadSnippetAssets(snippetId)
    

          setSuccessHtmlMsg(response.data);
          setShowSuccessMsg(true);
      } catch (error) {
        setShowSuccessMsg(false);
        setShowErrorMsg(true);
        console.log(error);
      }
      setShowLoader(false);
      setSubmitted(true)

      return true;
    }
    const uploadSnippetAssets = async (snippetId) => {
      let currentProgress = 5
      setProgress(currentProgress)

      setShowLoader(true);
      setSuccessHtmlMsg('');
    
      try {
          //const slicesToProcess = snippetData.wheelSettings.slices.filter(s => s.notUsed === false)
          const numSlices = snippetData.wheelSettings.slices.length;
          const delta = 95 / numSlices;

          for (let i=0; i<numSlices; i+=1) {
            if (snippetData.wheelSettings.slices[i].notUsed) {
              currentProgress += delta;
              setProgress(currentProgress)
              continue;
            }

            let url = `${process.env.REACT_APP_LION_API_URL}/Snippets/wheel/${snippetId}/${i}`;
            let fInfo = await spinningWheelElementManagerRef.current.askFrames(i);

            let dataToPost = {framesInfo: fInfo}
  
            const response = await axios.post(url, dataToPost);
            currentProgress += delta;
            setProgress(currentProgress)
            if (i === numSlices -1) setProgress(100)
          }

          
          setShowSuccessMsg(true);
      } catch (error) {
        setShowSuccessMsg(false);
        setShowErrorMsg(true);
        console.log(error);
      }
      setShowLoader(false);
      setSubmitted(true)

      return true;
    }
  const handleElementChange = (snippetInfo) => {
    //console.log(snippetInfo)
    setSnippetData(snippetInfo)

    if (activeErrorList.length > 0) {
      try {
        snippetDataValidationSchemaSpinningWheel.validateSync(snippetInfo, {abortEarly: false});
        setActiveErrorList([])
      }
      catch (e) {
        const errorList = getErrorListFromYupError(e)
        setActiveErrorList(errorList)
        return;
      }  
    }
  }
  const handleWheelSettingsChange = (settings) => {
    //console.log(settings)
    const newSnippetSettings = {...snippetData, wheelSettings: settings}

    setSnippetData(newSnippetSettings)

    if (activeErrorList.length > 0) {
      try {
        snippetDataValidationSchemaSpinningWheel.validateSync(snippetData, {abortEarly: false});
        setActiveErrorList([])
      }
      catch (e) {
        const errorList = getErrorListFromYupError(e)
        setActiveErrorList(errorList)
        return;
      }  
    }

  }
  const handleExpirySettingsChange = (settings) => {
    const newWheelSettings = {...snippetData.wheelSettings, expiry: settings}
    const newSnippetSettings = {...snippetData, wheelSettings: newWheelSettings}

    setSnippetData(newSnippetSettings)

  }

  const handleNavChange = async(navInfo) => {

    if (navInfo.actionType === 'Submit') {
          let valid = true;
          try {
            //console.log(snippetData)
            snippetDataValidationSchemaSpinningWheel.validateSync(snippetData, {abortEarly: false});
            setActiveErrorList([])
          }
          catch (e) {
            //console.log(JSON.parse(JSON.stringify(e)))
            const errorList = getErrorListFromYupError(e)            
            
            console.log(errorList)
            setActiveErrorList(errorList)
            if (errorList.length > 0)  return;
          }    
    
          setCurrentStep(navInfo.nextIndex);
          submitDataSnippet()
      }

    else if (currentStep === 0 && navInfo.nextIndex === 1) {
      try {
        //console.log(snippetData)
        snippetDataValidationSchemaSpinningWheel.validateSync(snippetData, {abortEarly: false});
        setActiveErrorList([])
      }
      catch (e) {
        //console.log(JSON.parse(JSON.stringify(e)))
        const errorList = getErrorListFromYupError(e)
        //yup can return also href errors that we don't want to validate
        // in this step. We need to supress this error here
        let hrefErrorIndex = errorList.findIndex(e => e.fieldName === 'wheelSettingsSlicesHref');
        if (hrefErrorIndex !== -1) errorList.splice(hrefErrorIndex, 1);
        hrefErrorIndex = errorList.findIndex(e => e.fieldName === 'wheelSettingsSlicesMapping');
        if (hrefErrorIndex !== -1) errorList.splice(hrefErrorIndex, 1);
        
        
        //console.log(errorList)
        setActiveErrorList(errorList)
        if (errorList.length > 0) return false;
      }    
      setCurrentStep(navInfo.nextIndex);
    }
    else if (currentStep === 1 && navInfo.nextIndex === 2) {
      try {
        snippetDataValidationSchemaSpinningWheel.validateSync(snippetData, {abortEarly: false});
        setActiveErrorList([])
      }
      catch (e) {
        //console.log(JSON.parse(JSON.stringify(e)))
        const errorList = getErrorListFromYupError(e)            
        setActiveErrorList(errorList)
        if (errorList.length > 0)  return;
      }    
      setCurrentStep(navInfo.nextIndex);
    }
    else setCurrentStep(navInfo.nextIndex);
    }
  
  const handleSaveExitClicked = () => {
      navigate("/ph/spinning")
  }
  const handleNextClicked = (tId, tJson) => {
      setTemplateId(tId)
      setTemplateHasTimeLabels(templateContainsTimeLabels(tJson));
      setCurrentStep(2);
  }
  const handleClose = () => {
      navigate("/ph/spinning")
  }

  const handleFramesChange = (frames) => {
    //console.log(frames)
    //test
    submitDataSnippet(frames)
  }

    return <div>
        <CcStepper2
            steps={[{ name: 'Configure Wheel', href: '#' },
                    { name: 'Configure Offers', href: '#' },
                    { name: 'Configure Expiry', href: '#' },
                    { name: 'Get Element', href: '#' },
                ]}
            currentStepIndex={currentStep}
        />
        <div className="border border-2 border-gray-200 rounded-md p-2">

            {currentStep === 0 && <SpinningWheelElementManager
                                    onChange={handleElementChange}
                                    validationErrorsList={activeErrorList}
                                    onFramesChange={handleFramesChange}
                                    snippetInfo={snippetData}
              />}
            {currentStep === 1 && <> <SpinningWheelOffersManager
                                    wheelSettings={snippetData.wheelSettings}
                                    onChange={handleWheelSettingsChange}
                                    validationErrorsList={activeErrorList}
              />
            </>}
            {currentStep === 2 && <> <SpinningWheelExpiryManager
                                    wheelSettings={snippetData.wheelSettings}
                                    onChange={handleExpirySettingsChange}
              />
            </>}

            {currentStep === 3 && <div className='flex flex-col items-center justify-center'>
                      <SpinningWheelElementManager noRender ref={spinningWheelElementManagerRef}
                                            onChange={handleElementChange}
                                            validationErrorsList={activeErrorList}
                                            onFramesChange={handleFramesChange}
                                            snippetInfo={snippetData}
                      />
                {showLoader && <> <div className='w-96'> <CcProgressBar variant="determinate" value={progress}/>
                </div></>}
                {showSuccessMsg && <SnippetCodeViewer numSnippets={1} html={successHtmlMsg} />}      
                {(showSuccessMsg || showErrorMsg) && <div> <CcActionButton variant="contained" onClick={handleClose} >Close</CcActionButton></div>}
            </div>}

            {currentStep !== 3 &&
                    <StepperNavButtons totalSteps={4}
                    currentStepNum={currentStep}
                    onChange={handleNavChange}
                    showClose={submitted}
                    onClose={handleClose}
                />
            }
        </div>

    </div>
}